theme_custom.base_url = theme_custom.api_base_url;
theme_custom.favLooks = []
// theme_custom.removeTieBar
theme_custom.removeTieBar = function() {
  $(".product-block-wrapper[data-product-type='tie-bar']").find('input[type="radio"]').prop("checked", false);
  $(".product-block-wrapper[data-product-type='tie-bar']").find('.swatch-wrap.unchecked-product').removeClass("unchecked-product");
  $(`.product-block-wrapper[data-product-type="tie-bar"]`).closest(".product-block-outer-wrapper").hide();
  $(`.mobile-tab-content-title[data-target="tie-bar"]`).hide();
  $(`.tabbed-content-block-inner-wrapper[data-tab-content="customize"] .continue-button.mobile-next-tab-btn-main`).hide();
  $(`.tabbed-content-block-inner-wrapper[data-tab-content="customize"] .continue-button:not(.mobile-next-tab-btn-main)`).show();
  $(".product-block-wrapper[data-product-type='tie-bar']").closest(".product-block-outer-wrapper").find(".color-title").text('')
}
//  theme_custom.priceUpdate function
theme_custom.priceUpdate = function() {
  var subTotal = 00;
  $(".product-item-wrap .swatch-color [type='radio']:checked").each(function() {
    if ($(this).closest('.product-block-wrapper').attr('data-product-type') != 'jacket' && $(this).closest('.product-block-wrapper').attr('data-product-type') != 'pants') {
      var variantDataGet = theme_custom.variantDataGet($(this));
      if (variantDataGet['variantPrice'] != undefined) {
        var selectedPrice = variantDataGet['variantPrice'];
        subTotal = subTotal + parseInt(selectedPrice);
      }
    }
  })
  $(".product-info-footer").find(".money").attr("data-price", subTotal).text(theme_custom.Shopify.formatMoney(subTotal, theme_custom.money_format));
  if (subTotal == 0) {
    $(".tabbed-content-block-outer-wrapper:first").find(".next-step").addClass("disabled");
  }
}
// theme_custom.productDataFromURL function
theme_custom.productDataFromURL = function() {
  var getUrl = window.location.href;
  let allProductsAvailable = true;
  if (getUrl.includes('?')) {
    var getUrlArr = getUrl.split('?'),
      getQueryParam = getUrl.split("?")[1],
      getProductItem = getQueryParam.split("&"),
      customizeLookProduct = [],
      productImageOld, productImageOneOld, productTypeOld;
    if (getProductItem.length > 0) {
      $(".next-step").removeClass("disabled");
      $(".tabbed-content-title").addClass("tab-header");
      if (getCookie("fit-finder-data") == "") {
        $(".tabbed-content-title[data-target='overview']").removeClass("tab-header");
      }
      $(".no-product-has-overview").hide();
      $(".custom-look-image img").addClass("hide");
      $(".shoes-customize-image, .pants-customize-image, .shirt-customize-image").removeClass("hide");
      for (var i = 0; i < getProductItem.length; i++) {
        var productHandleTitle = getProductItem[i].split("=")[0],
          productVarId = parseInt(getProductItem[i].split("=")[1]);
        // if(productHandleTitle.includes("suit")){
        // } else {
        // console.log("productVarId",$(`option[value="${productVarId}"]`));
        var currentOption = $(`option[value="${productVarId}"]`),
          currentVarintPrice = currentOption.attr('data-variant-price'),
          currentVarParent = currentOption.closest('.swatches-wrapper'),
          variantTitle = currentOption.attr('data-variant-title'),
          customizeLookProductHTML = '',
          swatches = currentOption.closest(".product-item-wrap").find('.product-swatches-main').html(),
          variantDropDown = currentOption.closest(".product-item-wrap").find('.product-var-dropdown').html();
        currentVarParent.find('input.selected-variant-id').attr('data-variant-id', productVarId).val(productVarId);
        currentVarParent.find('.swatch-element').attr('data-variant-id', productVarId);
        if (variantTitle == undefined || variantTitle == '') {
          continue;
        }
        var variantTitleArr = variantTitle.split(' / ');
        for (j = 0; j < variantTitleArr.length; j++) {
          var currentInput = $(`.swatch-wrap[data-value="${variantTitleArr[j]}"][data-product-handle="${productHandleTitle}"] input:radio`);
          if (currentInput.closest(".product-block-wrapper[data-product-type='shoes']").length > 0) {
            var currentInputProductHandle = currentInput.closest('.product-block').attr('data-product-type-handle');
            $(`.customize_product_title[data-product-type-handle="${currentInputProductHandle}"]`).click();
          }
          if (currentInput.closest(".product-block-wrapper[data-product-type='shoes']").length > 0) {
            $(".customize_product_title").removeClass("active");
            $(".customize_product_title[data-product-type-handle='" + productHandleTitle + "']").addClass("active");
            currentInput.closest(".product-block-wrapper[data-product-type='shoes']").find(".product-block.product-item-wrap").hide();
            currentInput.closest(".product-block-wrapper[data-product-type='shoes']").find(".product-block.product-item-wrap[data-product-type-handle='" + productHandleTitle + "']").show();
          }
          currentInput.prop('checked', true);
          currentVarParent.find(`input[data-option-index="${j}"]`).val(variantTitleArr[j]);
          if (currentInput.closest(".product-block-wrapper[data-product-type='suit']").length == 0) {
            currentInput.closest('.swatch-wrap').addClass("unchecked-product");
          }
          currentInput.closest('.product-block-outer-wrapper').find('.price-wrap').attr('data-product-price', currentVarintPrice).text(theme_custom.Shopify.formatMoney(currentVarintPrice, theme_custom.money_format)).show();
        }
        if (productHandleTitle.indexOf('shoe') != -1) {
          $(`.customize_product_title[data-product-type-handle='${productHandleTitle}']`).addClass("active");
          $(`.product-item-wrap[data-product-handle='${productHandleTitle}']`).show();
        }
        if ($('.product-block-wrapper[data-product-type="shirt"] .swatch-color input:radio:checked').length == 0) {
          if (($('.product-block-wrapper[data-product-type="neckties"] .swatch-color input:radio:checked').length > 0 && $('.product-block-wrapper[data-product-type="neckties"] .not-color input:radio:checked').length > 0) || $('.product-block-wrapper[data-product-type="bow-ties"] .swatch-color input:radio:checked').length > 0) {
            $('.shirt-customize-image').attr('src', $('.shirt-customize-image').attr('data-close-collar-image'));
          } else {
            $('.shirt-customize-image').attr('src', $('.shirt-customize-image').attr('data-open-collar-image'));
          }
        }
        var productImage = currentOption.attr('data-variant-image'),
          productImageOne = currentOption.attr('data-variant-image-one'),
          productVarImage = currentOption.attr('data-variant-featured-img'),
          productTitle = currentOption.closest('.product-item-wrap').find('.swatch-wrap:first-child').attr('data-product-title'),
          getVarPrice = currentOption.attr('data-variant-price'),
          variantInventoryPolicy = currentOption.attr('data-variant-inventory-policy'),
          variantInventoryQuantity = parseInt(currentOption.attr('data-variant-inventory-quantity')),
          getProductID = currentOption.attr('data-product-id'),
          productPriceWithMoney = theme_custom.Shopify.formatMoney(getVarPrice, theme_custom.money_format),
          getProductvarID = currentOption.attr('value'),
          productPrice = getVarPrice / 100,
          getProductHandle = currentOption.closest('.product-item-wrap').find('.swatch-wrap:first-child').attr('data-product-handle'),
          productType = currentOption.closest('.product-block-wrapper').attr("data-product-type").toLowerCase(),
          editRemoveBtnWrap = inputHiddenVal = productBlockVarData = editItem = removeItem = variantTitle = variantTitleWithOption = optionFirstName = optionFirstVal = optionSecondName = optionSecondVal = optionThirdName = optionThirdval = '';
        let fitData = {};
        if (getCookie('fit-finder-data')) {
          fitData = JSON.parse(getCookie('fit-finder-data'))
        }
        var variantNotFoundMessage = '<p class="error-message"></p><div class="estimated-variant-error-block-wrap"><span class="information-icon">!</span> <span class="estimated-date"></span></div>';
        if (variantTitle == undefined) {
          variantNotFoundMessage = `<p class="error-message error-show">${theme_custom.product_unavailable}</p>`;
        } else {
          if (variantInventoryPolicy == 'continue') {
            variantNotFoundMessage = `<p class="error-message"></p><div class="estimated-variant-error-block-wrap"><span class="information-icon">!</span> <span class="estimated-date"></span></div>`;
          } else {
            if (variantInventoryQuantity > 0) {
              variantNotFoundMessage = `<p class="error-message"></p><div class="estimated-variant-error-block-wrap"><span class="information-icon">!</span> <span class="estimated-date"></span></div>`;
            } else {
              variantNotFoundMessage = `<p class="error-message error-show">${theme_custom.product_out_of_stock}</p>`;
            }
          }
        }
        if (currentOption.closest(".product-block-wrapper[data-product-type='shirt']").length > 0 && fitData.shirt_sleeve == "00" && fitData.shirt_neck == "00") {
          variantNotFoundMessage = `<p class="error-message">${theme_custom.product_out_of_stock}</p>`;;
        }
        if (currentOption.closest(".product-block.product-item-wrap").find("input[data-option-index='0']").length > 0) {
          optionFirstName = currentOption.closest(".product-block.product-item-wrap").find("input[data-option-index='0']").attr("data-option-name-title"),
          optionFirstVal = currentOption.closest(".product-block.product-item-wrap").find("input[data-option-index='0']").val().replace(/"/g, "'");
        }
        if (currentOption.closest(".product-block.product-item-wrap").find("input[data-option-index='1']").length > 0) {
          optionSecondName = currentOption.closest(".product-block.product-item-wrap").find("input[data-option-index='1']").attr("data-option-name-title"),
          optionSecondVal = currentOption.closest(".product-block.product-item-wrap").find("input[data-option-index='1']").val().replace(/"/g, "'");
        }
        if (currentOption.closest(".product-block.product-item-wrap").find("input[data-option-index='2']").length > 0) {
          optionThirdName = currentOption.closest(".product-block.product-item-wrap").find("input[data-option-index='2']").attr("data-option-name-title"),
          optionThirdval = currentOption.closest(".product-block.product-item-wrap").find("input[data-option-index='2']").val().replace(/"/g, "'");
        }
        if (currentOption.closest(".product-block-wrapper[data-product-type='suit']").length > 0) {
          variantTitle = `<div class="jacket_option edit-remove-link" data-product-type="jacket" style="line-height: 25px;">Jacket <span class="option1">${theme_custom.jacketSize ? theme_custom.jacketSize : "" }</span> <span class="option2">${theme_custom.jacketType ? theme_custom.jacketType : ""}</span> <span class="option3"></span> <span class="combo-block-edit-item" data-variant-id="${getProductvarID}" data-product-handle="jacket-product"> | ${theme_custom.jacketSize && theme_custom.jacketType ? "Edit Item" :"Select size"} </span><p class="error-message" style="font-size: 12px;"></p><div class="estimated-variant-error-block-wrap"><span class="information-icon">!</span> <span class="estimated-date"></span></div></div>
                          <div class="pants_option edit-remove-link" data-product-type="pants" style="line-height: 25px;">Pants <span class="option1">${theme_custom.pantsWaist ? theme_custom.pantsWaist + "W" : ""}</span> <span class="option2">${theme_custom.pantsLength ? theme_custom.pantsLength + "H" : ""}</span> <span class="option3"></span> <span class="combo-block-edit-item" data-variant-id="${getProductvarID}" data-product-handle="pant-product"> | ${theme_custom.pantsWaist && theme_custom.pantsLength ? "Edit Item" :"Select size"} </span><p class="error-message" style="font-size: 12px;"></p><div class="estimated-variant-error-block-wrap"><span class="information-icon">!</span> <span class="estimated-date"></span></div></div>
                          <p class="pants-pro-tips" style="color: #001f49;font-size: 14px;"><b>Pro Tip:</b> We recommend selecting pants 2 inches larger than your jean size.</p>`;
        } else if (currentOption.closest(".product-block-wrapper[data-product-type='shirt']").length > 0) {
          var productVariantLink = '';
          if (optionFirstVal != '') {
            productVariantLink = `display: none"`;
          } else {
            productVariantLink = ''
          }
          variantTitleWithOption = '';
          var productVariantLink = buttonLabel = '';
          if (optionFirstVal != '' && optionSecondVal != '') {
            buttonLabel = 'Select Size'
          } else {
            buttonLabel = 'Edit Item'
          }
          if (optionFirstName && optionFirstVal && fitData.shirt_sleeve != "00" && fitData.shirt_neck != "00") {
            if (fitData.shirt_sleeve != '' && fitData.shirt_neck != '') {
              variantTitleWithOption = `${optionFirstName} <span class="option1">${fitData.shirt_neck} ${fitData.shirt_sleeve}</span>`;
            } else {
              variantTitleWithOption = `${optionFirstName} <span class="option1">${optionFirstVal}</span>`;
            }
          } else {
            variantTitleWithOption = `${optionFirstName} <span class="option1">NA</span>`;
          }
          if (optionSecondName && optionSecondVal && fitData.fit != "00") {
            if (fitData.fit != '') {
              variantTitleWithOption += `, ${optionSecondName} <span class="option2">${fitData.fit}</span>`
            } else {
              variantTitleWithOption += `, ${optionSecondName} <span class="option2">${optionSecondVal}</span>`
            }
          } else {
            variantTitleWithOption += `, ${optionSecondName} <span class="option2">NA</span>`;
          }
          if (optionThirdval) {
            variantTitleWithOption += ` - <span class="option3">${optionThirdval}</span>`;
          }
          if (fitData.shirt_sleeve != undefined && fitData.shirt_neck != undefined) {
            var updatedVariant = ` ${fitData.shirt_neck}  ${fitData.shirt_sleeve} / ${fitData.fit} / ${optionThirdval}`;
            var selectedVariantId = $(this).closest(".product-block-var-data").find(`.product-variant-option option[data-variant-title="${updatedVariant}"]`);
            if (!selectedVariantId) {
              variantNotFoundMessage = `<p class="error-message error-show">${theme_custom.product_unavailable}</p>`;
            } else {
              if (variantInventoryPolicy == 'continue') {
                variantNotFoundMessage = `<p class="error-message"></p><div class="estimated-variant-error-block-wrap"><span class="information-icon">!</span> <span class="estimated-date"></span></div>`;
              } else {
                if (variantInventoryQuantity > 0) {
                  variantNotFoundMessage = `<p class="error-message"></p><div class="estimated-variant-error-block-wrap"><span class="information-icon">!</span> <span class="estimated-date"></span></div>`;
                } else {
                  variantNotFoundMessage = `<p class="error-message error-show">${theme_custom.product_out_of_stock}</p>`;
                }
              }
            }
          }
          variantTitle = `<p class="variant-title" style="line-height: 25px;${productVariantLink}"> ${variantTitleWithOption} </p>`;
          inputHiddenVal = `<input type="hidden" class="overview-variant-id" data-variant-id="${getProductvarID}">`;
          if (variantInventoryQuantity == 0) {
            allProductsAvailable = false;
            productBlockVarData = 'product-block-var-data';
          } else {
            productBlockVarData = 'product-block-var-data';
          }
          if (optionSecondName && optionSecondVal && fitData.shirt_sleeve == "00" && fitData.shirt_neck == "00") {
            allProductsAvailable = true;
          }
          editItem = `<span class="link edit-item" data-variant-id="${getProductvarID}" data-product-handle="${getProductHandle}">${buttonLabel} | </span>`;
          removeItem = `<span class="link remove-item" data-variant-id="${getProductvarID}" data-product-handle="${getProductHandle}">Remove</span>`;
        } else if (currentOption.closest(".product-block-wrapper[data-product-type='vest']").length > 0) {
          var productVariantLink = buttonLabel = '';
          if (optionFirstVal != '') {
            buttonLabel = 'Select Size'
          } else {
            buttonLabel = 'Edit Item'
          }
          variantTitleWithOption = '';
          if (optionFirstName && optionFirstVal) {
            variantTitleWithOption = `${optionFirstName} <span class="option1">${optionFirstVal}</span>`;
          }
          if (optionSecondName && optionSecondVal) {
            variantTitleWithOption += `, ${optionSecondName} <span class="option2">${optionSecondVal}</span>`
          }
          if (optionThirdval) {
            variantTitleWithOption += ` - <span class="option3">${optionThirdval}</span>`;
          }
          variantTitle = `<p class="variant-title" style="line-height: 25px;${productVariantLink}"> ${variantTitleWithOption} </p>`;
          inputHiddenVal = `<input type="hidden" class="overview-variant-id" data-variant-id="${getProductvarID}">`;
          if (variantInventoryQuantity == 0) {
            productBlockVarData = 'product-block-var-data';
          } else {
            productBlockVarData = 'product-block-var-data';
          }
          editItem = `<span class="link edit-item" data-variant-id="${getProductvarID}" data-product-handle="${getProductHandle}">${buttonLabel} | </span>`;
          removeItem = `<span class="link remove-item" data-variant-id="${getProductvarID}" data-product-handle="${getProductHandle}">Remove</span>`;
        } else if (currentOption.closest(".product-block-wrapper[data-product-type='shoes']").length > 0) {
          var productVariantLink = buttonLabel = '';
          if (optionSecondVal == '') {
            buttonLabel = 'Select Size'
          } else {
            buttonLabel = 'Edit Item'
          }
          variantTitle = `<p class="variant-title" style="line-height: 25px;${productVariantLink}">${optionFirstName} - <span class="option1">${optionFirstVal.replace(/"/g, "'")}</span>, <span class="option2">${optionSecondVal.replace(/"/g, "'")}</span> </p>`;
          inputHiddenVal = `<input type="hidden" class="overview-variant-id" data-variant-id="${getProductvarID}">`;
          if (variantInventoryQuantity == 0) {
            productBlockVarData = 'product-block-var-data';
          } else {
            productBlockVarData = 'product-block-var-data';
          }
          editItem = `<span class="link edit-item" data-variant-id="${getProductvarID}" data-product-handle="${getProductHandle}">${buttonLabel} | </span>`;
          removeItem = `<span class="link remove-item" data-variant-id="${getProductvarID}" data-product-handle="${getProductHandle}">Remove</span>`;
        } else {
          variantTitleWithOption = '';
          if (optionFirstName && optionFirstVal) {
            variantTitleWithOption = `${optionFirstName} - <span class="option1">${optionFirstVal}</span>`;
          }
          if (optionSecondName && optionSecondVal) {
            variantTitleWithOption += `, ${optionSecondName} - <span class="option2">${optionSecondVal.replace(/"/g, "'")}</span>`
          }
          if (optionThirdName && optionThirdval) {
            variantTitleWithOption += ` - <span class="option3">${optionThirdval}</span>`;
          }
          variantTitle = `<p style="line-height: 25px;"> ${variantTitleWithOption} </p>`;
          inputHiddenVal = `<input type="hidden" class="overview-variant-id" data-variant-id="${getProductvarID}">`;
          if (variantInventoryQuantity == 0) {
            productBlockVarData = 'product-block-var-data';
          } else {
            productBlockVarData = 'product-block-var-data';
          }
          editItem = `<span class="link edit-item" data-variant-id="${getProductvarID}" data-product-handle="${getProductHandle}">Edit Item | </span>`;
          removeItem = `<span class="link remove-item" data-variant-id="${getProductvarID}" data-product-handle="${getProductHandle}">Remove</span>`;
        }
        $(this).closest(".product-block-outer-wrapper").find(".price-wrap").text("+", productPrice).show();
        $(".custom-look-image img." + productType + "-customize-image").removeClass("hide");
        var pantProTips = ``;
        if(productType == 'pants'){
          pantProTips = `<p class="pants-pro-tips" style="color: #001f49;font-size: 14px;"><b>Pro Tip:</b> We recommend selecting pants 2 inches larger than your jean size.</p>`;
        }
        if (productType == 'shirt') {
          productImageOld = productImage;
          productImageOneOld = productImageOne;
          productTypeOld = productType;
          setTimeout(function() {
            if (($('.product-block-wrapper[data-product-type="neckties"] .swatch-color input:radio:checked').length > 0 && $('.product-block-wrapper[data-product-type="neckties"] .not-color input:radio:checked').length > 0) || $('.product-block-wrapper[data-product-type="bow-ties"] .swatch-color input:radio:checked').length > 0) {
              $(".custom-look-image img." + productTypeOld + "-customize-image").attr("src", productImageOld);
            } else {
              $(".custom-look-image img." + productTypeOld + "-customize-image").attr("src", productImageOneOld);
            }
          }, 50);
        } else {
          $(".custom-look-image img." + productType + "-customize-image").attr("src", productImage);
        }
        $(this).closest(".product-block-outer-wrapper").find(".product-title .price-wrap").attr("data-product-price", getVarPrice).text('+' + productPrice).show();
        if (productType != 'suit') {
          editRemoveBtnWrap = `<div class="edit-remove-link" product-type="${productType}">
                                ${editItem}
                                ${removeItem}
                              </div>`
        } else {
          editRemoveBtnWrap = '';
        }
        customizeLookProductHTML = `<div class="product-data-card customize-look-overview-product ${productBlockVarData}" data-product-id="${getProductID}" data-variant-id="${getProductvarID}" data-product-handle="${getProductHandle}" data-product-type="${productType}">
              ${inputHiddenVal}
              <input type="hidden" name="looks-product-id" class="looks-product-id" value="${getProductID}">
              <input type="hidden" name="looks-product-handle" class="looks-product-handle" value="${getProductHandle}">
              <input type="hidden" name="product-variant-id" class="product-variant-id" value="${getProductvarID}" data-variant-inventory-quantity="${variantInventoryPolicy}" data-variant-inventory-quantity="${variantInventoryQuantity}">
              <div class="product-image">
                <img src="${productVarImage}" alt="${productTitle}" />
              </div>
              <div class="product-info-edit product-variant-wrap">
                <h4>${productTitle}</h4>
                <div class="product-variant-link">
                  ${variantTitle}
                </div>
                ${editRemoveBtnWrap}
                ${variantNotFoundMessage}
              </div>
              <div class="product-right">
                <span>${productPriceWithMoney}</span>
              </div>
              <div class="product-swatch-option" data-product-handle="${productHandleTitle}">
                <div class="product-swatches-main">
                  ${swatches}
                </div>
                <select class="product-variant-option hidden" data-prod-handle="medium-grey-pants">${variantDropDown}</select>
                <span class="error-message"></span>
                ${pantProTips}
                <button type="button" name="exchange-look-item" class="button button--full-width button--primary exchange-look-item disabled" data-product-type="${productType}" data-text="Updating..">Update</button>
              </div>
          </div>`;
        customizeLookProduct.push(customizeLookProductHTML);
        // }
      }
      $(".overview-product").html(customizeLookProduct);
      $(".customize-look-overview-product[data-product-type='jacket']").hide();
      $(".customize-look-overview-product[data-product-type='pants']").hide();
      $(".product-block-wrapper.product-not-found").each(function() {
        var target = $(this).attr("data-product-type");
        var error = `<p class='error-message error-show' style='color:red;font-size: 14px;position:static;text-align:left;padding:0;margin:0;'>${theme_custom.product_unavailable}</p>`;
        if (target == 'jacket') {
          $('.customize-look-overview-product .jacket_option').append(error);
        } else if (target == 'pants') {
          $('.customize-look-overview-product .pants_option').append(error);
        } else {
          $(`.customize-look-overview-product[data-product-type="${target}"] .customize-look-overview-product`).append(error);
        }
      });
      $(".swatch-wrap.unchecked-product").each(function() {
        var targetClor = $(this).find(".tool-tip").text();
        var suitProduct = $(this).closest(".product-block-outer-wrapper").attr("data-collection-title");
        if (suitProduct == 'jacket') {
          $(`.product-block-outer-wrapper[data-collection-title="suit-color"]`).find(".color-title").text(targetClor)
        } else {
          $(this).closest(".product-block-outer-wrapper").find(".color-title").text(targetClor)
        }
      });
      // if($(`.customize-look-overview-product:first`).find(`.product-variant-wrap h4`).text().includes(`Medium Grey`)) {
      //   $(`.medium-grey-suit-remove-msg`).show();
      // }
      if(localStorage.getItem("customise-look-button-for-add-look-into-event") == "true" && $(`.customize-look-overview-product:first`).find(`.product-variant-wrap h4`).text().includes(`Medium Grey`)) {
        $(`[data-tab-content='overview']`).find('.wishlist-add-event-part .add-to-event .add-event-look').addClass("redirect-to-event-page");
        $(`[data-tab-content='overview']`).find('.wishlist-add-event-part .add-to-event span').text("Back to event and continue other suit!");        
      }
    }
    // if($(`.customize-look-overview-product[data-product-handle="charcoal-suit"]`).length > 0) {
    //   $(`.add-to-event .add-event-look, .add-to-event .update-look-and-contine`).addClass("show-popup-for-upcoming-suit");
    // } else {
    //   $(`.add-to-event .add-event-look, .add-to-event .update-look-and-contine`).removeClass("show-popup-for-upcoming-suit");
    // }
    theme_custom.priceUpdate();
    theme_custom.setFitFinderData();
    if (getCookie("fit-finder-data") == "") {
      // $(`.vest_option`).addClass(`vest-not-selected`);
      $(`[data-product-type="vest"] .variant-title,[data-product-type="shirt"],[data-product-type="shoes"]`).find(".edit-item").attr("data-button-target", "select-size").text('Select Size | ');
      $(`[data-product-type="vest"] .variant-title,[data-product-type="shirt"] .variant-title, [data-product-type="shoes"] .variant-title`).addClass('hidden');
      $(`.jacket_option .combo-block-edit-item, .pants_option .combo-block-edit-item, [data-product-type="vest"] .edit-item, [data-product-type="shirt"] .edit-item, [data-product-type="shoes"] .edit-item`).attr('data-button-target', 'select-size');
    } else {
      $(`[data-product-type="vest"] .variant-title,[data-product-type="shirt"],[data-product-type="shoes"]`).find(".edit-item").attr("data-button-target", "edit-item").text('Edit Size | ');
      $(`[data-product-type="vest"] .variant-title,[data-product-type="shirt"] .variant-title, [data-product-type="shoes"] .variant-title`).removeClass('hidden');
      $(`.jacket_option .combo-block-edit-item, .pants_option .combo-block-edit-item, [data-product-type="vest"] .edit-item, [data-product-type="shirt"] .edit-item, [data-product-type="shoes"] .edit-item`).attr('data-button-target', 'edit-item');
      var fitFinderData = JSON.parse(getCookie('fit-finder-data')),
        shoe_size = fitFinderData.shoe_size;
      $(`[data-product-type="shoes"]`).find('.option2').text(shoe_size);
      $(`.customize-look-overview-product.product-block-var-data[data-product-type="shoes"] .product-swatches-main .swatch.size`).find('.swatch-element-item').removeClass("active");
      $(`.customize-look-overview-product.product-block-var-data[data-product-type="shoes"] .product-swatches-main .swatch.size`).find(`.swatch-element-item[data-title="${shoe_size}"]`).addClass("active")
    }
  }
}
// theme_custom.setUrlData function
theme_custom.setUrlData = function() {
  var url_arr = [];
  $(".product-block-wrapper").each(function() {
    var checked = $(this).find("[type='radio']:checked");
    if (checked.length > 0) {
      var variantDataGet = theme_custom.variantDataGet(checked);
      var productHandleVal = checked.parent(".swatch-wrap").find(".swatch-element").attr("data-product-handle"),
        productVarId = variantDataGet['variantId'];
      var product_data_url = '';
      product_data_url = productHandleVal + '=' + productVarId;
      url_arr.push(product_data_url)
    }
  });
  var new_url = url_arr.join("&");
  localStorage.setItem("customizerlookUrl", new_url);
  theme_custom.priceUpdate();
}
// theme_custom.mobile_accordion function
theme_custom.mobile_accordion = function() {
  if ($(window).width() < 991) {
    $(document).on('click', '.product-title:not(.not_toggle)', function(e) {
      e.preventDefault();
      var $this = $(this);
      $('.product-title').removeClass('active');
      if ($this.next().hasClass('show')) {
        $this.removeClass('active');
        $this.next().removeClass('show');
        $this.next().stop().slideUp(350);
      } else {
        $this.parent().parent().find('.product-block-wrapper').removeClass('show');
        $this.parent().parent().find('.product-block-wrapper').stop().slideUp(350);
        $this.toggleClass('active');
        $this.next().stop().toggleClass('show');
        $this.next().stop().slideToggle(350);
      }
    });
  }
}
// theme_custom.removeProductOnUncheck function 
theme_custom.removeProductOnUncheck = function(productVarId, prodHandle, productDataVal, target, checkParentRemoveProductFlag) {
  var newUrl = '',
    getProdVarId = productVarId,
    getProdHandle = prodHandle,
    removeProductVal = productDataVal;
  var getProductData = localStorage.getItem("customizerlookUrl");
  var productData = getProductData.split('&');
  for (i = 0; i < productData.length; i++) {
    if (productData[i].includes(removeProductVal)) {
      var removeProductFromUrl = "&" + removeProductVal,
        currentOption = $(`option[value="${getProdVarId}"]`),
        currentVarParent = currentOption.closest('.swatches-wrapper'),
        variantTitle = currentOption.attr('data-variant-title'),
        variantTitleArr = variantTitle.split(' / ');
      for (j = 0; j < variantTitleArr.length; j++) {
        var currentInput = $(`.swatch-wrap[data-value="${variantTitleArr[j]}"][data-product-handle="${getProdHandle}"] input:radio`);
        if (currentInput.closest('.swatch').hasClass('swatch-color')) {
          currentInput.prop('checked', false);
          if (currentInput.closest(".product-block-wrapper[data-product-type='neckties']").length > 0) {
            currentInput.closest(".product-block-wrapper[data-product-type='neckties']").find('.not-color input:radio').prop('checked', false);
          }
        }
        currentInput.closest('.product-block-outer-wrapper').find(".color-title").text('');
        currentInput.closest('.swatch-wrap').removeClass("unchecked-product");
      }
      var dataTarget = currentOption.closest(".product-block-wrapper").attr("data-product-type").toLowerCase();
      if (currentOption.closest('.product-block-wrapper[data-product-type="neckties"]').length > 0 || currentOption.closest('.product-block-wrapper[data-product-type="bow-ties"]').length > 0 || currentOption.closest('.product-block-wrapper[data-product-type="vest"]').length > 0 || currentOption.closest('.product-block-wrapper[data-product-type="hanky"]').length > 0 || currentOption.closest('.product-block-wrapper[data-product-type="belt"]').length > 0 || currentOption.closest('.product-block-wrapper[data-product-type="tie-bar"]').length > 0) {
        $(".custom-look-image img." + dataTarget + "-customize-image").addClass("hide");
        if (currentOption.closest('.product-block-wrapper[data-product-type="neckties"]').length > 0 || currentOption.closest('.product-block-wrapper[data-product-type="bow-ties"]').length > 0) {
          if ($('.product-block-wrapper[data-product-type="shirt"] .swatch-color input:radio:checked').length > 0) {
            var shirtVariantDataGet = theme_custom.variantDataGet($('.product-block-wrapper[data-product-type="shirt"] .swatch-color input:radio:checked'));
            if (shirtVariantDataGet['variantImageOne'] != undefined) {
              $('.shirt-customize-image').attr('src', shirtVariantDataGet['variantImageOne']);
            }
          } else {
            if (($('.product-block-wrapper[data-product-type="neckties"] .swatch-color input:radio:checked').length > 0 && $('.product-block-wrapper[data-product-type="neckties"] .not-color input:radio:checked').length > 0) || $('.product-block-wrapper[data-product-type="bow-ties"] .swatch-color input:radio:checked').length > 0) {
              $('.shirt-customize-image').attr('src', $('.shirt-customize-image').attr('data-close-collar-image'));
            } else {
              $('.shirt-customize-image').attr('src', $('.shirt-customize-image').attr('data-open-collar-image'));
            }
          }
        }
      }
      if (currentOption.closest('.product-block-wrapper[data-product-type="shirt"]').length > 0) {
        if (($('.product-block-wrapper[data-product-type="neckties"] .swatch-color input:radio:checked').length > 0 && $('.product-block-wrapper[data-product-type="neckties"] .not-color input:radio:checked').length > 0) || $('.product-block-wrapper[data-product-type="bow-ties"] .swatch-color input:radio:checked').length > 0) {
          $('.shirt-customize-image').attr('src', $('.shirt-customize-image').attr('data-close-collar-image'));
        } else {
          $('.shirt-customize-image').attr('src', $('.shirt-customize-image').attr('data-open-collar-image'));
        }
      }
      currentOption.closest(".product-block-outer-wrapper").find(".price-wrap").hide();
      theme_custom.priceUpdate();
      $(".customize-look-overview-product[data-variant-id='" + getProdVarId + "']").remove();
      if (removeProductFromUrl.includes("&")) {
        newUrl = getProductData.replace(removeProductFromUrl, "");
      } else if (removeProductFromUrl.includes("?")) {
        newUrl = getProductData.replace(removeProductFromUrl, "");
      }
      localStorage.setItem("customizerlookUrl", newUrl);
    }
  }
  if (checkParentRemoveProductFlag == 'remove-item' && target.hasClass('remove-item')) {
    window.location.reload();
    localStorage.setItem("page-refresh", "true");
  }
}
// theme_custom.favouriteLookImageCustomizer
theme_custom.favoriteLookImageCustomizer = function(lookID, button) {
  var button = button,
    form_data = new FormData(),
    fileVal = theme_custom.ImageURL,
    imageType = /image.*/;
  if (!fileVal.type.match(imageType)) {
    return;
  } else {
    form_data.append('lookImage', fileVal);
  }
  $.ajax({
    url: `${theme_custom.base_url}/api/look/picture/${lookID}`,
    method: "POST",
    timeout: "0",
    data: form_data,
    dataType: "json",
    "processData": false,
    "mimeType": "multipart/form-data",
    "contentType": false,
    headers: {
      "Authorization": 'Bearer ' + localStorage.getItem("customerToken")
    },
    beforeSend: function() {},
    success: function(result) {
      if (localStorage.getItem('editLookId') != null && localStorage.getItem('editLookName') != null) {
        $(".favourite-look-api-message").text("Look Updated successfully to Favorite").addClass("sucess-msg").removeClass("hidden").show();
        setTimeout(() => {
          button.removeClass("disabled");
          button.find(".button-title").text("Look Updated");
          button.find(".loading-overlay").addClass("hidden");
          $(".favourite-look-api-message").addClass("hidden");
          if (localStorage.getItem('editLookId') != null && localStorage.getItem('editLookName') != null && localStorage.getItem("look-for-favourite")) {
            localStorage.removeItem('editLookId');
            localStorage.removeItem('editLookName');
            localStorage.removeItem("look-for-favourite");
          }
          window.location.href = `/account?tab=favorite-look`
        }, 3000);
      } else {
        $(".favourite-look-api-message").text("Look added successfully to Favorite").addClass("sucess-msg").removeClass("hidden").show();
        setTimeout(() => {
          button.removeClass("disabled");
          button.find(".button-title").text("Added in Favorite");
          button.find(".loading-overlay").addClass("hidden");
          $(".favourite-look-api-message").addClass("hidden");
          window.location.href = `/account?tab=favorite-look`
        }, 3000);
      }
    },
    error: function(xhr, status, error) {
      if (xhr.responseJSON.message == 'Token is invalid or expired.') {
        $(".look-api-message").html('Something went wrong <a class="try-again-link" href="/account/login">Please try again</a>').css({
          'text-align': 'center',
          'color': 'red'
        });
        setTimeout(() => {
          theme_custom.removeLocalStorage();
          window.location.href = '/account/logout';
        }, 5000);
      } else {
        button.addClass("disabled").css("margin-top", "15px");
        $(".look-api-message").html(xhr.responseJSON.message).removeClass("look-api-message");
        setTimeout(() => {
          $('.update-profile-image-popup-wrapper .api_error').hide();
          $(".look-api-message").removeClass("look-api-message");
          button.removeClass("disabled");
        }, 3000);
      }
    }
  });
}
// theme_custom.customizeLookProductAjax
theme_custom.customizeLookProductAjax = function(button, parent) {
  var getProduct = parent.find(".customize-look-overview-product.product-block-var-data"),
    orderType = $(".order-type").val();
  var items = [];
  getProduct.each(function() {
    var productType = $(this).attr("data-product-type");
    var varId = $(this).find(`.product-variant-id`).val(),
      item = {};
    var jacketSelectedVariant = $(`.customize-look-overview-product.product-block-var-data[data-product-type="jacket"]`).find(".overview-variant-id").attr("data-variant-id"),
      jacketVarTitle = $(`.customize-look-overview-product.product-block-var-data[data-product-type="jacket"]`).find(`.product-variant-id`).attr("data-variant-title");
    if (productType == 'jacket') {
      item = {
        "id": varId,
        "quantity": 1,
        "properties": {
          "combo-variant-title": jacketVarTitle,
          "pant-variant-title": $(`.customize-look-overview-product.product-block-var-data[data-product-type="pants"]`).find(`.product-variant-id`).attr("data-variant-title")
        }
      }
    } else if (productType == 'pants') {
      item = {
        "id": varId,
        "quantity": 1,
        "properties": {
          "combo-variant-title": jacketVarTitle,
          "pant-variant-title": $(`.customize-look-overview-product.product-block-var-data[data-product-type="pants"]`).find(`.product-variant-id`).attr("data-variant-title")
        }
      }
    } else {
      item = {
        "id": varId,
        "quantity": 1
      }
    }
    items.push(item);
  })
  data = {
    items: items
  };
  console.log("data",data)
  button.addClass("disabled");
  if (orderType == 'virtual' || orderType == 'normal') {
    $.ajax({
      type: "GET",
      url: '/cart.js',
      dataType: 'json',
      success: function(resp) {
        var nullHash = {};
        for ([key, value] of Object.entries(resp.attributes)) {
          nullHash[key] = '';
        }
        $.ajax({
          type: "POST",
          url: '/cart/update.js',
          data: {
            attributes: nullHash
          },
          dataType: 'json'
        });
      }
    })
    jQuery.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function() {
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function() {
            button.find(".btn-title").text("Added To Cart");
            setTimeout(() => {
              button.removeClass("disabled").find(".btn-title").text("Add to Cart");
              window.location.href = "/cart";
            }, 2500);
          },
          error: function(xhr, status, error) {
            alert(xhr.responseJSON.description);
            button.find(".btn-title").text("Add To Cart");
            button.removeClass("disabled");
          }
        });
      }
    });
  } else {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
        button.find(".btn-title").text("Added to Cart");
        setTimeout(() => {
          button.removeClass("disabled").find(".btn-title").text("Add to Cart");
          window.location.href = "/cart";
        }, 2500);
      },
      error: function(xhr, status, error) {
        alert(xhr.responseJSON.description);
        button.find(".btn-title").text("Add To Cart");
        button.removeClass("disabled");
      }
    });
  }
}
// theme_custom.getEventData
theme_custom.getEventData = function(modalTarget) {
  data = {
    "eventType": "1",
    "page": "1",
    "host": "0",
    "limit": "100"
  }
  $.ajax({
    url: `${theme_custom.base_url}/api/customer/events`,
    method: "POST",
    data: data,
    dataType: "json",
    headers: {
      "Authorization": 'Bearer ' + localStorage.getItem("customerToken")
    },
    beforeSend: function() {},
    success: function(result) {
      $.fancybox.open(modalTarget);
      if (result.data.events.length > 0) {
        $(".page-loader").addClass("hidden");
        $("html,body").css("overflow", "visible");
        modalTarget.find(".empty-error-msg").addClass("hidden");
        modalTarget.find(".look-assign-wrapper").removeClass("hidden");
        var productDataCardArr = $(".customize-look-overview-product.product-block-var-data"),
          dataObj = {};
        theme_custom.newArray = [],
          productDataCardArr.each(function() {
            if ($(this).attr("data-variant-id") != '') {
              dataObj = {
                "product_id": $(this).attr("data-product-id"),
                "variant_id": $(this).attr("data-variant-id"),
                "product_handle": $(this).attr("data-product-handle"),
                "type": "looks"
              }
              theme_custom.newArray.push(dataObj);
            }
          })
        var dataOptionArray = result.data.events;
        var optionVal = '';
        optionVal += `<option value="">Select Event</option>`;
        for (let i = 0; i < dataOptionArray.length; i++) {
          if (dataOptionArray[i].hostedBy == "Me" || dataOptionArray[i].hostedBy == 'me') {
            optionVal += `<option value="${dataOptionArray[i].event_id}">${dataOptionArray[i].name}</option>`;
          }
        }
        $("select#event-id").html(optionVal);
        if (localStorage.getItem("eventLookName") != null && localStorage.getItem("eventLookId") != null && localStorage.getItem("customize-from-event") != null) {
          $(".create-event-look #look-name").val(localStorage.getItem("eventLookName"));
          $(".create-event-look #event-id").addClass("disabled").val(localStorage.getItem("set-event-id")).change();
          $(".add-event-look-api-button").removeClass("add-event-look-api-button").addClass("update-event-look-api-button").attr("data-text", "Look Updating...").find(".button-title").text("Update Look");
        }
        if (localStorage.getItem("customise-look-button-for-add-look-into-event") != null && localStorage.getItem("set-event-id") != null) {
          $('#event-id').addClass("disabled").val(localStorage.getItem("set-event-id")).change();
        }
      } else {
        $(".page-loader").addClass("hidden");
        $("html,body").css("overflow", "visible");
        modalTarget.find(".empty-error-msg").removeClass("hidden");
        modalTarget.find(".look-assign-wrapper").addClass("hidden");
      }
    },
    error: function(xhr, status, error) {
      if (xhr.responseJSON.message == 'Token is invalid or expired.') {
        $('.assign-member-look-popup-wrapper .api_error').show().html('Something went wrong <a class="try-again-link" href="/account/login">Please try again</a>').css({
          'text-align': 'center',
          'color': 'red'
        });
        setTimeout(() => {
          theme_custom.removeLocalStorage();
          window.location.href = '/account/logout';
        }, 5000);
      } else {
        $('.assign-member-look-popup-wrapper .api_error').show().html(xhr.responseJSON.message);
        setTimeout(() => {
          $('.assign-member-look-popup-wrapper .api_error').hide();
        }, 3000);
      }
    }
  });
}
// theme_custom.updateLookToEvent
theme_custom.updateLookToEvent = function(){
  data = {
    "eventType": "1",
    "page": "1",
    "host": "0",
    "limit": "100"
  }
  $.ajax({
    url: `${theme_custom.base_url}/api/customer/events`,
    method: "POST",
    data: data,
    dataType: "json",
    headers: {
      "Authorization": 'Bearer ' + localStorage.getItem("customerToken")
    },
    beforeSend: function() {},
    success: function(result) {
      if (result.data.events.length > 0) {
        $(".page-loader").removeClass("hidden");
        var productDataCardArr = $(".customize-look-overview-product.product-block-var-data"), dataObj = {};
        theme_custom.newArray = [],
        productDataCardArr.each(function() {
          if ($(this).attr("data-variant-id") != '') {
            dataObj = {
              "product_id": $(this).attr("data-product-id"),
              "variant_id": $(this).attr("data-variant-id"),
              "product_handle": $(this).attr("data-product-handle"),
              "type": "looks"
            }
            theme_custom.newArray.push(dataObj);
          }
        })
        var dataOptionArray = result.data.events;
        var optionVal = '';
        optionVal += `<option value="">Select Event</option>`;
        for (let i = 0; i < dataOptionArray.length; i++) {
          if (dataOptionArray[i].hostedBy == "Me" || dataOptionArray[i].hostedBy == 'me') {
            optionVal += `<option value="${dataOptionArray[i].event_id}">${dataOptionArray[i].name}</option>`;
          }
        }
        $("select#event-id").html(optionVal);
        if (localStorage.getItem("eventLookName") != null && localStorage.getItem("eventLookId") != null && localStorage.getItem("customize-from-event") != null) {
          $(".create-event-look #look-name").val(localStorage.getItem("eventLookName"));
          $(".create-event-look #event-id").val(localStorage.getItem("set-event-id")).change();
          $(".create-event-look .add-event-look-api-button").removeClass("add-event-look-api-button").addClass("update-event-look-api-button").attr("data-text", "Look Updating...").find(".button-title").text("Update Look");
        }
        $(".page-loader").removeClass("hidden");
        var heightScroll = $("#shopify-section-header").height() + $(".breadcrumb").height() + 30;
        $('html, body').stop().animate({
          'scrollTop': $(".tabbed-content-wrapper").offset().top - heightScroll
        }, 900);
        $('html, body').css({
          "overflow": "hidden"
        })        
        html2canvas(document.querySelector(".custom-look-image"), {
          allowTaint: true,
          useCORS: true,
        }).then(function(canvas) {
          $(".page-loader").removeClass("hidden");
          theme_custom.image_url = canvas.toDataURL("image/png", 1.0);
          theme_custom.ImageURL = theme_custom.dataURLtoFile(theme_custom.image_url, 'custom-look.png');
          $(".page-loader").removeClass("hidden");
          $(".update-event-look-api-button").click();
        }).catch((e) => {
          console.log(e);
        });
      }
    },
    error: function(xhr, status, error) {
      if (xhr.responseJSON.message == 'Token is invalid or expired.') {
        setTimeout(() => {
          theme_custom.removeLocalStorage();
          window.location.href = '/account/logout';
        }, 5000);
      } else {
        alert(xhr.responseJSON.message);
        setTimeout(() => {
          $('.assign-member-look-popup-wrapper .api_error').hide();
        }, 3000);
      }
    }
  });
}
// theme_custom.b64toBlob
theme_custom.b64toBlob = function(b64Data, contentType, sliceSize) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;
  var byteCharacters = atob(b64Data);
  var byteArrays = [];
  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  var blob = new Blob(byteArrays, {
    type: contentType
  });
  return blob;
}
// theme_custom.Create Look Image 
theme_custom.createLookImage = function() {
  var heightScroll = $("#shopify-section-header").height() + $(".breadcrumb").height() + 30;
  $('html, body').stop().animate({
    'scrollTop': $(".tabbed-content-wrapper").offset().top - heightScroll
  }, 900);
  $('html, body').css({
    "overflow": "hidden"
  })
  setTimeout(() => {
    html2canvas(document.querySelector(".custom-look-image"), {
      allowTaint: true,
      useCORS: true,
    }).then(function(canvas) {
      theme_custom.image_url = canvas.toDataURL("image/png", 1.0);
      theme_custom.ImageURL = theme_custom.dataURLtoFile(theme_custom.image_url, 'custom-look.png');
      $('html, body').css({
        "overflow": "visible"
      })
      if (getCookie("fit-finder-data") == "") {
        $(".tabbed-content-block-inner-wrapper[data-tab-content='find-your-fit']").find(".next-step").addClass("disabled")
      } else {
        $(".tabbed-content-block-inner-wrapper[data-tab-content='find-your-fit']").find(".next-step").removeClass("disabled");
      }
      $('html, body').stop().animate({
        'scrollTop': $(".tabbed-content-wrapper").offset().top - $("#shopify-section-header").height() + 30
      }, 900);
    }).catch((e) => {
      console.log(e);
    });
  }, 1500);
}
// Selected variant data get
theme_custom.variantDataGet = function(input) {
  var variantDataGetArr = [];
  var $this = input,
    parent = $this.closest('.swatch-outer-wrapper');
  var productId = $this.closest('.swatch-wrap').find('label').attr('data-product-id'),
    variantTitle = '',
    variantId, variantImage, variantPrice, selectedOption;
  if (parent.find('[data-option-index="0"]').length > 0) {
    variantTitle = parent.find('[data-option-index="0"]').val().replace(/"/g, "'");
  }
  if (parent.find('[data-option-index="1"]').length > 0) {
    variantTitle = variantTitle + ' / ' + parent.find('[data-option-index="1"]').val().replace(/"/g, "'");
  }
  if (parent.find('[data-option-index="2"]').length > 0) {
    variantTitle = variantTitle + ' / ' + parent.find('[data-option-index="2"]').val().replace(/"/g, "'");
  }
  selectedOption = $(`[data-product-id="${productId}"][data-variant-title="${variantTitle.replace(/"/g, "'")}"]`);
  if (selectedOption.length <= 0) {
    let items = document.querySelectorAll(`[data-product-id="${productId}"]`);
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      if (parseInt(item.getAttribute('data-variant-inventory-quantity')) > 0) {
        selectedOption = $(item);
        break;
      }
    }
  }
  $(`[data-product-id="${productId}"]`).attr('selected', false);
  selectedOption.attr('selected', true);
  variantPrice = selectedOption.attr('data-variant-price');
  variantId = selectedOption.attr('value');
  variantImage = selectedOption.attr('data-variant-image');
  variantImageOne = selectedOption.attr('data-variant-image-one');
  variantInventoryQuantity = selectedOption.attr('data-variant-inventory-quantity');
  variantDataGetArr['productId'] = productId;
  variantDataGetArr['variantId'] = variantId;
  variantDataGetArr['variantImage'] = variantImage;
  variantDataGetArr['variantPrice'] = variantPrice;
  variantDataGetArr['variantTitle'] = variantTitle;
  variantDataGetArr['variantImageOne'] = variantImageOne;
  variantDataGetArr['variantQty'] = variantInventoryQuantity;
  return variantDataGetArr;
}
// theme_custom.setFinderData
theme_custom.setFinderData = function() {
  var getFitFinderData = JSON.parse(getCookie("fit-finder-data"));
  var jacketType = getFitFinderData.jacketSize.split(":");
  var jacketTypeVal = '';
  if (jacketType[1] == "S") {
    jacketTypeVal = 'Short'
  } else if (jacketType[1] == "R") {
    jacketTypeVal = 'Regular'
  } else if (jacketType[1] == "L") {
    jacketTypeVal = 'Long'
  }
  // Jacket - Size 
  theme_custom.jacketSize = jacketType[0];
  theme_custom.jacketType = jacketTypeVal;
  // Pants Size
  theme_custom.pantsWaist = getFitFinderData.pants_waist;
  theme_custom.pantsLength = getFitFinderData.pants_hight;
  // Set Shirt Default Sizes
  if (theme_custom.shirt_neck == '00' || !theme_custom.shirt_neck) {
    theme_custom.shirt_neck = "13.5";
  }
  if (theme_custom.shirt_sleeve == '00' || !theme_custom.shirt_sleeve) {
    theme_custom.shirt_sleeve = "32/33";
  }
  if (theme_custom.shirt_sleeve_fit == '00' || !theme_custom.shirt_sleeve_fit) {
    theme_custom.shirt_sleeve_fit = "Slim";
  }
  //alert(theme_custom.shirt_neck + ' | ' + theme_custom.shirt_sleeve + ' | ' + theme_custom.shirt_sleeve_fit);
  if ($(`.product-block-wrapper[data-product-type="jacket"]`).length > 0) {
    $(`.product-block-wrapper[data-product-type="jacket"]`).find(`[data-option-name="chest-size"]`).val(theme_custom.jacketSize);
    $(`.product-block-wrapper[data-product-type="jacket"]`).find(`[data-option-name="style"]`).val(theme_custom.jacketType);
  }
  if ($(`.product-block-wrapper[data-product-type="vest"]`).length > 0) {
    $(`.product-block-wrapper[data-product-type="vest"]`).find(`[data-option-name="chest-size"]`).val(theme_custom.jacketSize);
    $(`.product-block-wrapper[data-product-type="vest"]`).find(`[data-option-name="style"]`).val(theme_custom.jacketType);
  }
  if ($(`.product-block-wrapper[data-product-type="pants"]`).length > 0) {
    $(`.product-block-wrapper[data-product-type="pants"]`).find(`[data-option-name="waist"]`).val(theme_custom.pantsWaist);
    $(`.product-block-wrapper[data-product-type="pants"]`).find(`[data-option-name="length"]`).val(theme_custom.pantsLength);
  }
  if ($(`.product-block-wrapper[data-product-type="shirt"]`).length > 0) {
    $(`.product-block-wrapper[data-product-type="shirt"]`).find(`[data-option-name="size"]`).val(theme_custom.shirt_neck + ' ' + theme_custom.shirt_sleeve);
    $(`.product-block-wrapper[data-product-type="shirt"]`).find(`[data-option-name="style"]`).val(theme_custom.shirt_sleeve_fit);
  }
  if ($(`.product-block-wrapper[data-product-type="shoes"]`).length > 0) {
    $(`.product-block-wrapper[data-product-type="shoes"]`).find(`[data-option-name="size"]`).val(theme_custom.shoesSize);
  }
  var new_url_arr = [];
  $(".product-block-wrapper").each(function() {
    if ($(this).find(".swatch-color input:radio:checked").length > 0) {
      var currentProduct = $(this).find(".swatch-color input:radio:checked").closest(".product-item-wrap");
      var variantTitle = selectedOption = '';
      if (currentProduct.find('[data-option-index="0"]').length > 0) {
        variantTitle = currentProduct.find('[data-option-index="0"]').val();
      }
      if (currentProduct.find('[data-option-index="1"]').length > 0) {
        variantTitle = variantTitle + ' / ' + currentProduct.find('[data-option-index="1"]').val();
      }
      if (currentProduct.find('[data-option-index="2"] input:checked').length > 0) {
        variantTitle = variantTitle + ' / ' + currentProduct.find('[data-option-index="2"]').val();
      }
      selectedOption = currentProduct.find(`[data-variant-title="${variantTitle}"]`).val();
      if (!selectedOption) {
        $(this).addClass("product-not-found");
        selectedOption = currentProduct.find(`[data-available="true"]`).val();
      }
      if (selectedOption != undefined) {
        var product_data_url = '';
        product_data_url = currentProduct.attr("data-product-handle") + '=' + selectedOption;
        new_url_arr.push(product_data_url)
      }
    }
  });
  var look_new_url = '?' + new_url_arr.join("&");
  history.pushState({}, null, look_new_url);
  theme_custom.priceUpdate();
}
theme_custom.handleize = function(e) {
  return e.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "")
}
theme_custom.setFitFinderData = function() {
  let parent = $('.tabbed-content-block-inner-wrapper.overview-tab');
  let getData = getCookie('fit-finder-data');
  if (getData) {
    const data = JSON.parse(getData);
    // <!-- chest-size style -->
    let jacketSize = data.jacket_size;
    let jacketType = data.jacket_type;
    var jacketData = data.jacketSize.split(":");
    if (jacketData) {
      if (jacketData[1]) {
        if (jacketData[1] == "S") {
          jacketType = 'short'
        } else if (jacketData[1] == "R") {
          jacketType = 'regular'
        } else if (jacketData[1] == "L") {
          jacketType = 'long'
        }
      }
      if (jacketData[0]) {
        jacketSize = jacketData[0];
      }
    }
    let jacket = $('.customize-look-overview-product[data-product-type="jacket"]', parent);
    let jacketChestSize = $('.swatch.chest-size', jacket);
    let jacketStyle = $('.swatch.style', jacket);
    if (jacketChestSize.length > 0) {
      let item = $(`.swatch-element-item[data-value="${jacketSize}"]`, jacketChestSize).click();
    }
    if (jacketStyle.length > 0) {
      let item = $(`.swatch-element-item[data-value="${jacketType}"]`, jacketStyle).click();
    }
    if (jacketChestSize.length > 0 || jacketStyle.length > 0) {
      let btn = $(`.exchange-look-item`, jacket);
      if (btn.hasClass('disabled')) {} else {
        btn.click();
      }
    }
    let vest = $('.customize-look-overview-product[data-product-type="vest"]', parent);
    let vestChestSize = $('.swatch.chest-size', vest);
    let vestStyle = $('.swatch.style', vest);
    if (vestChestSize.length > 0) {
      let item = $(`.swatch-element-item[data-value="${jacketSize}"]`, vestChestSize).click();
    }
    if (vestStyle.length > 0) {
      let item = $(`.swatch-element-item[data-value="${jacketType}"]`, vestStyle).click();
    }
    if (vestChestSize.length > 0 || vestStyle.length > 0) {
      let btn = $(`.exchange-look-item`, vest);
      if (btn.hasClass('disabled')) {} else {
        btn.click();
      }
    }
    let pantsHeight = data.pants_hight;
    let pantsWaist = data.pants_waist;
    let pants = $('.customize-look-overview-product[data-product-type="pants"]', parent);
    let paintWaist = $('.swatch.waist', pants);
    let paintLength = $('.swatch.length', pants);
    if (paintWaist.length > 0) {
      let item = $(`.swatch-element-item[data-value="${pantsWaist}"]`, paintWaist).click();
    }
    if (paintLength.length > 0) {
      let item = $(`.swatch-element-item[data-value="${pantsHeight}"]`, paintLength).click();
    }
    if (paintWaist.length > 0 || paintLength.length > 0) {
      let btn = $(`.exchange-look-item`, pants);
      if (btn.hasClass('disabled')) {} else {
        btn.click();
      }
    }
    let shirtSleeve = data.shirt_sleeve;
    let shirtNeck = data.shirt_neck;
    let shirts = $('.customize-look-overview-product[data-product-type="shirt"]', parent);
    let shirtDiv = $('.swatch.size', shirts);
    if (shirtDiv.length > 0) {
      let shirtVal = theme_custom.handleize(`${shirtNeck} ${shirtSleeve}`);
      let item = $(`.swatch-element-item[data-value="${shirtVal}"]`, shirtDiv).click();
    }
    let shirtStyleDiv = $('.swatch.style', shirts);
    if (shirtStyleDiv.length > 0) {
      let shirtStyleVal = theme_custom.handleize(`${data.fit}`);
      let item = $(`.swatch-element-item[data-value="${shirtStyleVal}"]`, shirtStyleDiv).click();
    }
    if (shirtDiv.length > 0 && shirtStyleDiv.length > 0) {
      let btn = $(`.exchange-look-item`, shirts);
      if (btn.hasClass('disabled')) {} else {
        btn.click();
      }
    }
    let shoeSize = data.shoe_size;
    let shoes = $('.customize-look-overview-product[data-product-type="shoes"]', parent);
    let shoesSize = $('.swatch.size', shoes);
    if (shoesSize.length > 0) {
      let item = $(`.swatch-element-item[data-value="${shoeSize}"]`, shoes).click();
      let btn = $(`.exchange-look-item`, shoesSize);
      if (btn.hasClass('disabled')) {} else {
        btn.click();
      }
    }
  }
  setTimeout(() => {
    if ($('.tabbed-content-title.active[data-target="overview"]').length > 0) {
      theme_custom.setNoramlProductVariants();
    }
  }, 1000);
}
// theme_custom.customize_product_clickEvent function
theme_custom.customize_product_clickEvent = function() {
  $(document).on("click", ".combo-block-edit-item", function() {
    var target = $(this).closest(`.edit-remove-link`).attr("data-product-type");
    if (target == 'pants') {
      var option1 = $(this).closest(`.edit-remove-link`).find('.option1').text().toLocaleLowerCase().replace(' / ', '').replace("W", '').replace("w", '')
      var option2 = $(this).closest(`.edit-remove-link`).find('.option2').text().toLocaleLowerCase().replace(' / ', '').replace("H", '').replace("h", '');
    } else {
      var option1 = $(this).closest(`.edit-remove-link`).find('.option1').text().toLocaleLowerCase().replace(' / ', '')
      var option2 = $(this).closest(`.edit-remove-link`).find('.option2').text().toLocaleLowerCase().replace(' / ', '');
    }
    if (target == 'jacket') {
      if (option1 != '') {
        $(`.product-block-var-data[data-product-type="jacket"] [data-option-swatch-index="0"]`).find(`.swatch-element-item`).removeClass('active').siblings(`.swatch-element-item[data-value="${option1}"]`).addClass("active");
      }
      if (option2 != '') {
        $(`.product-block-var-data[data-product-type="jacket"] [data-option-swatch-index="1"]`).find(`.swatch-element-item`).removeClass('active').siblings(`.swatch-element-item[data-value="${option2}"]`).addClass("active")
      }
    }
    if (target == 'pants') {
      if (option1 != '') {
        $(`.product-block-var-data[data-product-type="pants"] [data-option-swatch-index="0"]`).find(`.swatch-element-item`).removeClass('active').siblings(`.swatch-element-item[data-value="${option1}"]`).addClass("active");
      }
      if (option2 != '') {
        $(`.product-block-var-data[data-product-type="pants"] [data-option-swatch-index="1"]`).find(`.swatch-element-item`).removeClass('active').siblings(`.swatch-element-item[data-value="${option2}"]`).addClass("active")
      }
    }
    if (target == 'vest') {
      if (option1 != '') {
        $(`.product-block-var-data[data-product-type="vest"] [data-option-swatch-index="0"]`).find(`.swatch-element-item`).removeClass('active').siblings(`.swatch-element-item[data-value="${option1}"]`).addClass("active");
      }
      if (option2 != '') {
        $(`.product-block-var-data[data-product-type="vest"] [data-option-swatch-index="1"]`).find(`.swatch-element-item`).removeClass('active').siblings(`.swatch-element-item[data-value="${option2}"]`).addClass("active")
      }
    }
    $(`.product-data-card[data-product-type="${target}"]`).find(".edit-item").trigger("click");
  });
  var clickEvent = document.ontouchstart !== null ? 'click' : 'touchstart';
  $(document).on(clickEvent, ".product-swatches-main .swatch-element-item", function() {
    let parent = $(this).closest('.product-swatch-option');
    let select = $('.product-variant-option', parent);
    let subParent = $(this).closest('.swatch');
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    var selectOptionVar = parent.find('.product-variant-option option');
    var productVariantTitle = [];
    selectOptionVar.each(function() {
      productVariantTitle.push($(this).attr("data-variant-title"));
    });
    let variantTitle = "";
    $('.swatches', parent).each((i, item) => {
      if (variantTitle == "") {
        variantTitle = $('.swatch-element-item.active', item).attr('data-title');
      } else {
        variantTitle = variantTitle + ' / ' + $('.swatch-element-item.active', item).attr('data-title');
      }
    })
    var selectedVarariantId = parent.find($(`.product-variant-option option[data-variant-title="${variantTitle}"]`)).val();
    var selectedVarInventoryQty = parseInt(parent.find($(`.product-variant-option option[data-variant-title="${variantTitle}"]`)).attr("data-variant-inventory-quantity"));
    var selectedVarInventoryPolicy = parent.find($(`.product-variant-option option[data-variant-title="${variantTitle}"]`)).attr("data-variant-inventory-policy");
    var productType = parent.closest(`.product-data-card`).attr("data-product-type");
    if (!selectedVarariantId) {
      parent.find(".error-message").addClass("error-show").text(theme_custom.product_unavailable);
      parent.find(".exchange-look-item").addClass("disabled").text("Unavailable");
      if (productType == 'jacket') {
        $(`.jacket_option`).find(`.error-message`).addClass('error-show').text(theme_custom.product_unavailable)
      } else if (productType == 'pants') {
        $(`.pants_option`).find(`.error-message`).addClass('error-show').text(theme_custom.product_unavailable)
      } else {
        parent.find(".error-message").addClass('error-show').text(theme_custom.product_unavailable)
      }
    } else {
      var targetVariant = parent.find($(`.product-variant-option option[data-variant-title="${variantTitle}"]`))
      parent.closest(".product-item").find(".img img").attr("src", targetVariant.attr("data-variant-image"));
      if (selectedVarInventoryPolicy == 'continue') {
        parent.find(".error-message").removeClass("error-show").text('').fadeOut();
        parent.find(".exchange-look-item").removeClass("disabled").text("Update");
        parent.find(".product-variant-option").val(selectedVarariantId);
      } else {
        if (selectedVarInventoryQty <= 0) {
          parent.find(".error-message").addClass("error-show").text(theme_custom.product_out_of_stock);
          parent.find(".exchange-look-item").addClass("disabled").text("Out of Stock");
          if (productType == 'jacket') {
            $(`.jacket_option`).find(`.error-message`).addClass("error-show").text(theme_custom.product_out_of_stock)
          } else if (productType == 'pants') {
            $(`.pants_option`).find(`.error-message`).addClass("error-show").text(theme_custom.product_out_of_stock)
          } else{
            parent.find(".error-message").addClass("error-show").text(theme_custom.product_out_of_stock)
          }
        } else {
          parent.find(".error-message").removeClass("error-show").text('').fadeOut();
          parent.find(".exchange-look-item").removeClass("disabled").text("Update");
          parent.find(".product-variant-option").val(selectedVarariantId);
        }
      }
    }
  });
  $(document).on("click", ".tab-header", function() {
    var currentTab = $(this).attr("data-target");
    if (currentTab == "overview") {
      $(".tabbed-content-block-inner-wrapper[data-tab-content='accessories'] .next-step").click();;
    } else {
      $(".tabbed-content-title, .tabbed-content-block-inner-wrapper").removeClass("active");
      $(this).addClass("active");
      $(".tabbed-content-block-inner-wrapper[data-tab-content='" + currentTab + "']").addClass("active");
      if ($(this).attr("data-target") == 'customize' || $(this).attr("data-target") == 'accessories') {
        $(".custom-look-image").addClass("image-zoom");
      } else {
        $(".custom-look-image").removeClass("image-zoom");
      }
    }
  });
  $(document).on("click", ".mobile-customize-tab li.mobile-tab-content-title", function() {
    var currentTab = $(this).attr("data-target");
    var parent = $(this).closest('.tabbed-content-block-inner-wrapper');
    parent.find(".mobile-tab-content-title").removeClass("active");
    parent.find(".product-block-outer-wrapper").removeClass("active");
    $(this).addClass("active");
    $(".product-block-outer-wrapper .product-block-wrapper[data-product-type='" + currentTab + "']").closest('.product-block-outer-wrapper').addClass("active");
    if (parent.hasClass('active')) {
      var new_parent = parent.find(".mobile-customize-tab");
      if (new_parent.find("li:not(:last-child)")) {
        $(this).closest(".tabbed-content-block-outer-wrapper").find(".button-wrapper .continue-button:last-child").hide();
        $(this).closest(".tabbed-content-block-outer-wrapper").find(".button-wrapper .mobile-next-tab-btn-main").show();
      }
      if (!$(this).next() || !$(this).next().is(':visible')) {
        $(this).closest(".tabbed-content-block-outer-wrapper").find(".button-wrapper .continue-button:last-child").show();
        $(this).closest(".tabbed-content-block-outer-wrapper").find(".button-wrapper .mobile-next-tab-btn-main").hide();
      }
    }
  });
  // exchange-look-item
  $(document).on("click", ".exchange-look-item", function() {
    // new code update
    var current_product_option = ''
    if ($(this).closest(`.product-swatch-option`).find(`[data-option-swatch-index="0"]`).length > 0) {
      current_product_option = $(this).closest(`.product-swatch-option`).find(`[data-option-swatch-index="0"]`).find(`.swatch-element-item.active`).attr(`data-title`);
    }
    if ($(this).closest(`.product-swatch-option`).find(`[data-option-swatch-index="1"]`).length > 0) {
      current_product_option = current_product_option + ' / ' + $(this).closest(`.product-swatch-option`).find(`[data-option-swatch-index="1"]`).find(`.swatch-element-item.active`).attr(`data-title`);
    }
    if ($(this).closest(`.product-swatch-option`).find(`[data-option-swatch-index="2"]`).length > 0) {
      current_product_option = current_product_option + ' / ' + $(this).closest(`.product-swatch-option`).find(`[data-option-swatch-index="2"]`).find(`.swatch-element-item.active`).attr(`data-title`);
    }
    // alert(current_product_option_first, current_product_option_second,  current_product_option_third);
    var targetVarTitle = `${current_product_option}`;
    $(this).closest(".product-swatch-option").find(`select.product-variant-option option[data-variant-title="${targetVarTitle}"]`).prop("selected", true);
    var button = $(this),
      targetVarID = $(this).closest(".product-swatch-option").find("select.product-variant-option").val(),      
      buttonText = button.attr("data-text"),
      productHandle = button.parent(".product-swatch-option").attr("data-product-handle"),
      productType = button.attr('data-product-type');
      button.removeClass("disabled"),
      productImg = $(this).closest(".product-swatch-option").find(`select.product-variant-option option[data-variant-title="${targetVarTitle}"]`).attr("data-variant-featured-img");
      button.text(buttonText);
    var targetVarTitleArr = targetVarTitle.split(" / ");
    if (targetVarTitleArr[0] != '') {
      $(`.customize-look-overview-product[data-product-handle="${productHandle}"]`).find(".option1").text(targetVarTitleArr[0]);
    }
    if (targetVarTitleArr[1] != '') {
      $(`.customize-look-overview-product[data-product-handle="${productHandle}"]`).find(".option2").text(targetVarTitleArr[1]);
    }
    if (targetVarTitleArr[2] != '') {
      $(`.customize-look-overview-product[data-product-handle="${productHandle}"]`).find(".option3").text(targetVarTitleArr[2]);
    }
    $(`.customize-look-overview-product[data-product-handle="${productHandle}"]`).attr("data-variant-id", targetVarID);
    $(`.customize-look-overview-product[data-product-handle="${productHandle}"]`).find(".product-variant-id").val(targetVarID);
    $(`.customize-look-overview-product[data-product-handle="${productHandle}"]`).find(".product-variant-id").attr("data-variant-title",targetVarTitle);
    $(`.customize-look-overview-product[data-product-handle="${productHandle}"]`).find(".product-image img").attr('src', productImg);
    $(`.customize-look-overview-product[data-product-handle="${productHandle}"]`).find(".overview-variant-id").attr("data-variant-id", targetVarID);
    $(`.customize-look-overview-product[data-product-handle="${productHandle}"]`).find(".product-variant-option").val(targetVarID).change();    
    if (productType == 'jacket') {
      $(`.customize-look-overview-product[data-product-type="suit"] .jacket_option .option1`).text(targetVarTitleArr[0]);
      $(`.customize-look-overview-product[data-product-type="suit"] .jacket_option .option2`).text(" / " + targetVarTitleArr[1]);
      $(`.customize-look-overview-product[data-product-type="suit"] .jacket_option .option3`).text(" / " + targetVarTitleArr[2]);
      targetVarTitleArr[0];
      $(`.customize-look-overview-product[data-product-type="suit"] .jacket_option`).find(".combo-block-edit-item").text("| Edit Item").attr('data-button-target', 'edit-item');
      $(`.product-data-card[data-product-type="jacket"]`).find(`.error-message`).removeClass("error-show").text('');
      $(`.jacket_option`).find(`.error-message`).removeClass("error-show").text('');
    } else if (productType == 'pants') {
      $(`.customize-look-overview-product[data-product-type="suit"] .pants_option .option1`).text(targetVarTitleArr[0] + 'W');
      $(`.customize-look-overview-product[data-product-type="suit"] .pants_option .option2`).text(" / " + targetVarTitleArr[1] + 'H');
      $(`.customize-look-overview-product[data-product-type="suit"] .pants_option .option3`).text(" / " + targetVarTitleArr[2]);
      $(`.product-data-card[data-product-type="pants"]`).find(`.error-message`).removeClass("error-show").text('');
      $(`.pants_option`).find(`.error-message`).removeClass("error-show").text('');
      $(`.customize-look-overview-product[data-product-type="suit"] .pants_option`).find(".combo-block-edit-item").text("| Edit Item").attr('data-button-target', 'edit-item');
      $(`.customize-look-overview-product[data-product-type="suit"] .pants_option`).find(".error-message").removeClass("error-show").addClass("hidden");
    } else if (productType == 'vest') {
      $(`.customize-look-overview-product[data-product-type="vest"] .product-variant-link .option1`).text(targetVarTitleArr[0]);
      $(`.customize-look-overview-product[data-product-type="vest"] .product-variant-link .option2`).text(targetVarTitleArr[1]);
      $(`.customize-look-overview-product[data-product-type="vest"] .product-variant-link`).find(".variant-title").show();
      $(`.product-data-card[data-product-type="vest"]`).find(`.error-message`).removeClass("error-show").text('');
      $(`.customize-look-overview-product[data-product-type="vest"] .edit-remove-link`).find(".edit-item").text("Edit Item | ").attr('data-button-target', 'edit-item');
      $(`[data-product-type="vest"] .variant-title`).removeClass('hidden');
      $(`[data-product-type="vest"]`).find(`.error-message`).removeClass("error-show").text('');
    } else if (productType == 'shirt') {
      $(`.customize-look-overview-product[data-product-type="shirt"] .product-variant-link .option1`).text(targetVarTitleArr[0]);
      $(`.customize-look-overview-product[data-product-type="shirt"] .product-variant-link .option2`).text(targetVarTitleArr[1]);
      $(`.customize-look-overview-product[data-product-type="shirt"] .product-variant-link`).find(".variant-title").show();
      $(`[data-product-type="shirt"] .variant-title`).removeClass('hidden');
      $(`.customize-look-overview-product[data-product-type="shirt"]`).find(`.error-message`).removeClass("error-show");
      $(`.customize-look-overview-product[data-product-type="shirt"] .edit-remove-link`).find(".edit-item").text("Edit Item | ").attr('data-button-target', 'edit-item');
      $(`[data-product-type="shirt"]`).find(`.error-message`).removeClass("error-show").text('');
    } else if (productType == 'shoes') {
      $(`.customize-look-overview-product[data-product-type="shoes"] .product-variant-link .option2`).text(targetVarTitleArr[1]);
      $(`.customize-look-overview-product[data-product-type="shoes"] .edit-remove-link`).find(".edit-item").text("Edit Item | ").attr('data-button-target', 'edit-item');
      $(`.customize-look-overview-product[data-product-type="shoes"] .product-variant-link`).find(".variant-title").show();
      $(`.customize-look-overview-product[data-product-type="shoes"]`).find(`.error-message`).removeClass("error-show");
      $(`[data-product-type="shoes"] .variant-title`).removeClass('hidden');
      $(`[data-product-type="shoes"]`).find(`.error-message`).removeClass("error-show").text('');
    }
    let parent = $(this).closest('.product-swatch-option');
    let error = $(`.customize-look-overview-product[data-product-handle="${parent.attr('data-product-handle')}"] .error-message`);
    let selectedItem = $(this).closest(".product-swatch-option").find("select.product-variant-option option:selected").val();
    let variantInventoryQuantity = parseInt($(this).closest(".product-swatch-option").find("select.product-variant-option option:selected").attr("data-variant-inventory-quantity"));
    let variantInventoryPolicy = $(this).closest(".product-swatch-option").find("select.product-variant-option option:selected").attr("data-variant-inventory-policy");
    let variantEstimateDate = new Date($(this).closest(".product-swatch-option").find("select.product-variant-option option:selected").attr("data-variant-estimate-date"));
    $(".product-out-of-stock-error").addClass("hidden").removeClass("error-show");
    $(`.customize-look-overview-product[data-product-type="${productType}"]`).find(`.product-info-edit .error-message`).removeClass("error-show");
    if (!selectedItem) {
      if (productType == 'jacket') {
        $(`.product-variant-wrap[data-product-type="jacket"]`).find(".product-block-wrap .error-message").addClass("error-show").text(theme_custom.product_unavailable);
      } else if (productType == 'pants') {
        $(`.product-variant-wrap[data-product-type="pants"]`).find(".product-block-wrap .error-message").addClass("error-show").text(theme_custom.product_unavailable);
      } else {
        parent.find(".error-message").addClass("error-show").text(theme_custom.product_unavailable);
        parent.find('.product-block-wrap .error-message').addClass("error-show");
      }
    } else {
      if (variantInventoryPolicy == 'continue') {
        $(`.customize-look-overview-product[data-product-type="${productType}"]`).find('.exchange-look-item').removeClass('disabled');
        $(`.customize-look-overview-product[data-product-type="${productType}"]`).find(".error-message").removeClass("error-show").text('');
        $(`.customize-look-overview-product[data-product-type="${productType}"]`).find('.exchange-look-item .error-message').removeClass("error-show");
        $(`.customize-look-overview-product[data-product-type="${productType}"]`).addClass('product-block-var-data');
        if(variantInventoryQuantity <= 0){
          if(theme_custom.current_date < variantEstimateDate) {
            if(variantInventoryPolicy == "continue" && variantInventoryQuantity <= 0){
              if (productType == 'jacket') {
                $(`.product-variant-wrap .jacket_option`).find(".estimated-variant-error-block-wrap").addClass("active").find(`.estimated-date`).text(`Estimated ship date: ${variantEstimateDate}`);
              } else if (productType == 'pants') {
                $(`.product-variant-wrap .pants_option`).find(".estimated-variant-error-block-wrap").addClass("active").find(`.estimated-date`).text(`Estimated ship date: ${variantEstimateDate}`);
              } else {
                $(`.product-block-var-data[data-product-type=${productType}]`).find(".estimated-variant-error-block-wrap").addClass("active").find(`.estimated-date`).text(`Estimated ship date: ${variantEstimateDate}`);
              }
            } 
          }
        } else {
          if (productType == 'jacket') {
            $(`.product-variant-wrap .jacket_option`).find(".estimated-variant-error-block-wrap").removeClass("active").find(`.estimated-date`).text(``);
          } else if (productType == 'pants') {
            $(`.product-variant-wrap .pants_option`).find(".estimated-variant-error-block-wrap").removeClass("active").find(`.estimated-date`).text(``);
          } else {
            $(`.product-block-var-data[data-product-type=${productType}]`).find(".estimated-variant-error-block-wrap").removeClass("active").find(`.estimated-date`).text(``);
          }
        }
      } else {
        if (variantInventoryQuantity > 0) {
          if (productType == 'jacket') {
            $(`.product-variant-wrap[data-product-type="jacket"]`).find(".product-swatch-option .error-message").find('.product-block-wrap .error-message').removeClass("error-show");
            $(`.product-variant-wrap[data-product-type="jacket"]`).find('.exchange-look-item').addClass('disabled').find(".button-label").text("Update");
            $(`.customize-look-overview-product[data-product-type="${productType}"]`).addClass('product-block-var-data');
          } else if (productType == 'pants') {
            $(`.product-variant-wrap[data-product-type="pants"]`).find(".product-swatch-option .error-message").find('.product-block-wrap .error-message').removeClass("error-show");
            $(`.product-variant-wrap[data-product-type="pants"]`).find('.exchange-look-item').addClass('disabled').find(".button-label").text("Update");
            $(`.customize-look-overview-product[data-product-type="${productType}"]`).addClass('product-block-var-data');
          } else {
            $(`.product-block-var-data[data-product-type=${productType}]`).find('.product-block-wrap .error-message').removeClass("error-show");
            $(`.customize-look-overview-product[data-product-type="${productType}"]`).addClass('product-block-var-data');
            $(`.customize-look-overview-product[data-product-type="${productType}"]`).find('.exchange-look-item').addClass('disabled').find(".button-label").text("Update");
          }
        } else {
          $(`.customize-look-overview-product[data-product-type="${productType}"]`).removeClass('product-block-var-data');
          var parentType = parent.attr("data-product-type");
          if (productType == 'jacket') {
            $(`.product-variant-wrap[data-product-type="jacket"]`).find(".product-swatch-option .error-message").addClass("error-show").text(theme_custom.product_out_of_stock);
            $(`.product-variant-wrap[data-product-type="jacket"]`).find('.exchange-look-item').addClass('disabled').find(".button-label").text("Out of Stock");
          } else if (productType == 'pants') {
            $(`.product-variant-wrap[data-product-type="pants"]`).find(".product-swatch-option .error-message").addClass("error-show").text(theme_custom.product_out_of_stock);
            $(`.product-variant-wrap[data-product-type="pants"]`).find('.exchange-look-item').addClass('disabled').find(".button-label").text("Out of Stock");
          } else {
            $(`.product-block-var-data[data-product-type=${productType}]`).find(".product-swatch-option .error-message").addClass("error-show").text(theme_custom.product_out_of_stock);
            $(`.product-block-var-data[data-product-type=${productType}]`).find('.exchange-look-item').addClass('disabled').find(".button-label").text("Out of Stock");
          }
        }
      }
    }
    button.text("Update");
    $(".fancybox-button").click();
    if (productType == 'neckties' || productType == 'hanky' || productType == 'bow-ties' || productType == 'tie-bar' || productType == 'belt') {
      setTimeout(() => {
        theme_custom.updatePreviousSwatch(productType);
      }, 500);
    }
  })
  // product option popup open
  $(document).on("click", ".edit-item", function() {
    let parent = $(this).closest('.customize-look-overview-product');
    let btn = $('.exchange-look-item', parent);
    var currentProductType = $(this).closest(".edit-remove-link").attr("product-type");
    if (currentProductType == 'jacket' || currentProductType == 'pants' || currentProductType == 'vest') {
      var target = $(`.product-data-card[data-product-type="${currentProductType}"]`).find(".product-swatch-option");
      var option1 = $(this).closest(".edit-remove-link").find(".option1").text().toLocaleLowerCase().replace(' / ', '').replace("W", '').replace("w", ''),
        option2 = $(this).closest(".edit-remove-link").find(".option2").text().toLocaleLowerCase().replace(' / ', '').replace('H', '').replace('h', '');
      if (option1 != '') {
        target.find(`[data-option-swatch-index="0"]`).find(`.swatch-element-item`).removeClass("active");
        target.find(`[data-option-swatch-index="0"]`).find(`.swatch-element-item[data-value="${option1}"]`).addClass("active");
      }
      if (option2 != '') {
        target.find(`[data-option-swatch-index="1"]`).find(`.swatch-element-item`).removeClass("active");
        target.find(`[data-option-swatch-index="1"]`).find(`.swatch-element-item[data-value="${option2}"]`).addClass("active");
      }
    }
    if (parent.find(".error-message.error-show").length > 0) {
      btn.addClass('disabled');
    } else {
      if (currentProductType == 'jacket') {
        $(`.customize-look-overview-product[data-product-type="jacket"]`).find(".product-swatch-option .exchange-look-item").removeClass("disabled");
      } else if (currentProductType == 'pants') {
        $(`.customize-look-overview-product[data-product-type="pants"]`).find(".product-swatch-option .exchange-look-item").removeClass("disabled");
      } else if (currentProductType == 'vest') {
        $(`.customize-look-overview-product[data-product-type="vest"]`).find(".product-swatch-option .exchange-look-item").removeClass("disabled");
      } else {
        if (btn) {
          btn.removeClass('disabled');
        }
      }
    }
    if ($(this).attr('data-product-handle') == 'jacket-product') {
      $.fancybox.open($(`.customize-look-overview-product[data-product-type="jacket"] .product-swatch-option`));
    } else if ($(this).attr('data-product-handle') == 'pant-product') {
      $.fancybox.open($(`.customize-look-overview-product[data-product-type="pants"] .product-swatch-option`));
    } else if ($(this).attr('data-product-handle') == 'vest-product') {
      $.fancybox.open($(`.customize-look-overview-product[data-product-type="vest"] .product-swatch-option`));
    } else {
      var productSwatchOption = $(this).closest(".customize-look-overview-product").find(".product-swatch-option");
      $.fancybox.open(productSwatchOption);
    }
  });
  // favorite-event-button 
  $(document).on("click", ".favorite-event-button", function() {
    if($(`.customize-look-overview-product:first`).find(`.product-variant-wrap h4`).text().includes(`Medium Grey`)) {
      $(`.medium-grey-suit-remove-msg`).show()
      return false;
    }
    if (localStorage.getItem("editLookName") != null && localStorage.getItem("editLookId") != null) {
      $(`[name="look-name"]`).val(localStorage.getItem("editLookName"));
    }
    $(".page-loader").removeClass("hidden");
    var target = $(this).closest(".customize-your-look-page").find(".favourite-look-wrapper");
    var productDataCardArr = $(".customize-look-overview-product.product-block-var-data"),
      dataObj = {};
    theme_custom.prodArray = [],
      productDataCardArr.each(function() {
        dataObj = {
          "product_id": $(this).attr("data-product-id"),
          "variant_id": $(this).attr("data-variant-id"),
          "product_handle": $(this).attr("data-product-handle"),
          "type": "looks"
        }
        theme_custom.prodArray.push(dataObj);
      });
    theme_custom.getFavoriteLooks(function(looks) {
      theme_custom.favLooks = looks;
      $(".page-loader").addClass("hidden");
      $.fancybox.open(target);
    })
    theme_custom.createLookImage();
  });
  // add-to-cart-button Click Event 
  $(document).on("click", ".add-to-cart-button", function() {
    if ($(`[data-button-target="select-size"]`).length > 0) {
      $('html, body').stop().animate({
        'scrollTop': $(`[data-button-target="select-size"]:first`).offset().top - $("#shopify-section-header").height() + 10
      }, "slow");
      $(".product-out-of-stock-error").removeClass("hidden").addClass("active");
      var errorMsg = `Please Select Size!`;
      if ($(`.jacket_option`).find(`[data-button-target="select-size"]`).length > 0) {
        $(`.jacket_option`).find(`.error-message`).addClass("error-show").text(errorMsg);
      } else {
        $(`.jacket_option`).find(`.error-message`).removeClass("error-show").text('');
      }
      if ($(`.pants_option`).find(`[data-button-target="select-size"]`).length > 0) {
        $(`.pants_option`).find(`.error-message`).addClass("error-show").text(errorMsg);
      } else {
        $(`.pants_option`).find(`.error-message`).removeClass("error-show").text('');
      }
      if ($(`.product-data-card[data-product-type="vest"]`).find(`[data-button-target="select-size"]`).length > 0) {
        $(`.product-data-card[data-product-type="vest"]`).find(`.error-message`).addClass("error-show").text(errorMsg);
      } else {
        $(`.product-data-card[data-product-type="vest"]`).find(`.error-message`).removeClass("error-show").text('');
      }
      if ($(`.product-data-card[data-product-type="shirt"]`).find(`[data-button-target="select-size"]`).length > 0) {
        $(`.product-data-card[data-product-type="shirt"]`).find(`.error-message`).addClass("error-show").text(errorMsg);
      } else {
        $(`.product-data-card[data-product-type="shirt"]`).find(`.error-message`).removeClass("error-show").text('');
      }
      if ($(`.product-data-card[data-product-type="shoes"]`).find(`[data-button-target="select-size"]`).length > 0) {
        $(`.product-data-card[data-product-type="shoes"]`).find(`.error-message`).addClass("error-show").text(errorMsg);
      } else {
        $(`.product-data-card[data-product-type="shoes"]`).find(`.error-message`).removeClass("error-show").text('');
      }
      return false;
    }
    if ($(".error-message:visible").length > 0) {
      $(".product-out-of-stock-error").addClass("hidden").removeClass("active");
      let parent = $(".error-message.error-show").closest('.customize-look-overview-product');
      if (parent.length > 0) {
        $('html, body').stop().animate({
          'scrollTop': $(parent).offset().top - $("#shopify-section-header").height() + 10
        }, "slow");
        $(".product-out-of-stock-error").addClass("hidden").removeClass("active");
        return false;
      }
    }
    var button = $(this),
      button_text = $(this).attr("data-text"),
      parent = $(this).closest(".template-page-customize-your-look .product-info-wrap");
    button.find(".btn-title").text(button_text);
    button.addClass("disabled");
    theme_custom.customizeLookProductAjax(button, parent);
  })
  // add-event-look Click Event 
  $(document).on("click", ".add-event-look", function() {
    // if($(this).hasClass(`show-popup-for-upcoming-suit`)) {
    //   if($(`.customizer-page-sliver-suit-coming-soon-msg`).hasClass("active")){
    //     $(`.customizer-page-sliver-suit-coming-soon-msg`).removeClass("active");
    //   } else {
    //     $(`.customizer-page-sliver-suit-coming-soon-msg`).addClass("active");
    //   }
    // } else {
    if($(`.customize-look-overview-product:first`).find(`.product-variant-wrap h4`).text().includes(`Medium Grey`)) {
      $(`.medium-grey-suit-remove-msg`).show();
      if($(this).hasClass(`redirect-to-event-page`)){
        localStorage.removeItem("customizerlookUrl");
        localStorage.setItem("back-to-event-page","true");
        localStorage.removeItem(`customise-look-button-for-add-look-into-event`);
        window.location.href = `/pages/create-event`;
      } else {
        return false;      
      }
    }
    $("html,body").css("overflow", "hidden");
    $(".page-loader").removeClass("hidden");
    var modalTarget = $(this).closest(".customize-your-look-page").find(".create-event-look");
    theme_custom.getEventData(modalTarget);
    theme_custom.createLookImage();
    
    // }
  });
  $(document).on("click", ".update-look-and-contine", function() {
    // if($(this).hasClass(`show-popup-for-upcoming-suit`)) {
    //   if($(`.customizer-page-sliver-suit-coming-soon-msg`).hasClass("active")){
    //     $(`.customizer-page-sliver-suit-coming-soon-msg`).removeClass("active");
    //   } else {
    //     $(`.customizer-page-sliver-suit-coming-soon-msg`).addClass("active");
    //   }
    // } else {
      $("html,body").css("overflow", "hidden");
      $(".page-loader").removeClass("hidden");
      theme_custom.updateLookToEvent();
    // }
  });
  // update-event-look-api-button Click Event 
  $(document).on("click", ".update-event-look-api-button", function(e) {
    theme_custom.button = $(this);
    var button = $(this);
    button.addClass("disabled");
    button.find(".loading-overlay").removeClass("hidden");
    button.find(".button-title").text(button.attr("data-text"));
    theme_custom.removeLookFromEvent(theme_custom.button);
  })
  $(".next-step").click(function() {
    if ($(this).closest(`.tabbed-content-block-inner-wrapper[data-tab-content="accessories"]`).length > 0) {
      var currentURL = window.location.href;
      var domainData = currentURL.split('?')[0];
      var newURL = domainData + '?' + localStorage.getItem('customizerlookUrl')
      window.history.pushState({}, '', newURL);
      theme_custom.productDataFromURL();
    }
    if ($(this).closest(".tabbed-content-block-inner-wrapper[data-tab-content='personalize']").length > 0 || $(this).closest(".tabbed-content-block-inner-wrapper[data-tab-content='customize']").length > 0) {
      $(".custom-look-image").addClass("image-zoom");
    } else {
      $(".custom-look-image").removeClass("image-zoom");
    }
    var targetElm = $('.tabbed-content-wrapper .tabbed-content-header li.active'),
      nextTargetElm = targetElm.next().attr("data-target");
    targetElm.removeClass("active").next().addClass("active");
    $(".tabbed-content-block-inner-wrapper").removeClass("active");
    $(".tabbed-content-block-inner-wrapper[data-tab-content='" + nextTargetElm + "']").addClass("active");
    var nextstep = $(".tabbed-content-block-inner-wrapper[data-tab-content='" + nextTargetElm + "']").addClass("active");
    if (nextstep.hasClass("active")) {
      nextstep.find(".button-wrapper .continue-button:last-child").hide();
      nextstep.find(".button-wrapper .continue-button.mobile-next-tab-btn-main").show();
    }
    $(this).closest('.tabbed-content-block-inner-wrapper').next().find('.mobile-customize-tab .mobile-tab-content-title:first-child').click();
    if (targetElm.attr("data-target") == 'overview' && getCookie("fit-finder-data") != "") {
      setTimeout(() => {
        theme_custom.productDataFromURL();
      }, 500);
    } else if (targetElm.nextAll().attr("data-target") == 'overview' && getCookie("fit-finder-data") != "") {
      $(".tabbed-content-block-inner-wrapper[data-tab-content='overview']").addClass("active");
      $(".tabbed-content-block-inner-wrapper[data-tab-content='find-your-fit']").removeClass("active");
      $(".tabbed-content-wrapper .tabbed-content-header li").removeClass("active");
      $(".tabbed-content-title[data-target='overview']").addClass("active");
      $('html, body').stop().animate({
        'scrollTop': $(".tabbed-content-wrapper").offset().top - $("#shopify-section-header").height() + 30
      }, 900);
      theme_custom.setFinderData();
      setTimeout(() => {
        theme_custom.productDataFromURL();
      }, 500);
    }
    if ($(this).closest(".tabbed-content-block-inner-wrapper[data-tab-content='personalize']").length > 0) {
      var vestHandle = $(".tabbed-content-block-inner-wrapper[data-tab-content='personalize']").find("input:radio:checked").closest(".product-block.product-item-wrap").attr("data-vest-handle");
      $(`.product-block-wrapper[data-product-type="vest"]`).find(".product-block.product-item-wrap").hide();
      if ($(`.product-block-wrapper[data-product-type="vest"]`).find(".product-block.product-item-wrap[data-product-handle='" + vestHandle + "']").length > 0) {
        $(`.product-block-outer-wrapper.product-block-wrapper[data-product-type="vest"]`).show();
        $(`.product-block-wrapper[data-product-type="vest"]`).find(".product-block.product-item-wrap[data-product-handle='" + vestHandle + "']").show();
      } else {
        $(`.product-block-outer-wrapper.product-block-wrapper[data-product-type="vest"]`).hide();
      }
    }
    if ($(this).closest(".tabbed-content-block-inner-wrapper[data-tab-content='find-your-fit']").length > 0) {
      theme_custom.setFinderData();
      setTimeout(() => {
        theme_custom.productDataFromURL();
      }, 500);
    }
    if ($(this).closest(".tabbed-content-block-inner-wrapper[data-tab-content='accessories']").length > 0) {
      if (getCookie("fit-finder-data") == "") {
        $(this).closest(".tabbed-content-block-inner-wrapper").next(".tabbed-content-block-inner-wrapper").find(".next-step").addClass("disabled")
      } else {
        $(this).closest(".tabbed-content-block-inner-wrapper").next(".tabbed-content-block-inner-wrapper").find(".next-step").removeClass("disabled")
      }
    } else {
      $('html, body').stop().animate({
        'scrollTop': $(".tabbed-content-wrapper").offset().top - $("#shopify-section-header").height() + 30
      }, 900);
    }
  });
  // mobile customizer tab next button click event
  $(".mobile-next-tab-btn-main .next-tab-step").click(function(e) {
    // $(".mobile-customize-tab .mobile-tab-content-title").find('.active').trigger( "click" );
    var parent = $(this).closest(".tabbed-content-block-inner-wrapper").find(".mobile-customize-tab");
    parent.children('.active').next('li').trigger("click");
    if (parent.find("li:last-child").hasClass('active')) {
      $(this).closest(".tabbed-content-block-outer-wrapper").find(".continue-button").show();
      $(this).parent(".mobile-next-tab-btn-main").hide();
    }
  });
  $(".prev-step").click(function(e) {
    if ($(this).closest(".tabbed-content-block-inner-wrapper[data-tab-content='accessories']").length > 0 ||  $(this).closest(".tabbed-content-block-inner-wrapper[data-tab-content='find-your-fit']").length > 0) {
      $(".custom-look-image").addClass("image-zoom");
    } else {
      $(".custom-look-image").removeClass("image-zoom");
    }
    var targetElm = $('.tabbed-content-wrapper .tabbed-content-header li.active'),
      prevTargetElm = targetElm.prev().attr("data-target");
    targetElm.removeClass("active").prev().addClass("active");
    $(".tabbed-content-block-inner-wrapper").removeClass("active");
    $(".tabbed-content-block-inner-wrapper[data-tab-content='" + prevTargetElm + "']").addClass("active");
    var prevStep = $(".tabbed-content-block-inner-wrapper[data-tab-content='" + prevTargetElm + "']").addClass("active");
    if (prevStep.hasClass("active")) {
      prevStep.find(".button-wrapper .continue-button:last-child").hide();
      prevStep.find(".button-wrapper .continue-button.mobile-next-tab-btn-main").show();
    }
    $(this).closest('.tabbed-content-block-inner-wrapper').prev().find('.button-wrapper .continue-button:last-child').show();
    $(this).closest('.tabbed-content-block-inner-wrapper').prev().find('.button-wrapper .continue-button.mobile-next-tab-btn-main').hide();
    $(this).closest('.tabbed-content-block-inner-wrapper').prev().find('.mobile-customize-tab .mobile-tab-content-title:first-child').click();
    $('html, body').stop().animate({
      'scrollTop': $(".tabbed-content-wrapper").offset().top - $("#shopify-section-header").height() + 30
    }, 900);
  });
  $('.swatch-wrap input[type=radio]').change(function() {
    var colorVal = $(this).val(),
      parent = $(this).closest(".product-block-wrapper");
    $(".form-error", parent).remove();
    $(this).closest(".product-block-outer-wrapper").find(".product-title-wrap .color-title").text(colorVal);
    if ($(this).closest(".tabbed-content-block-inner-wrapper[data-tab-content='personalize']").length > 0) {
      $(".vest-customize-image").addClass("hide");
      if ($(".product-block-wrapper[data-product-type='jacket']")) {
        var inputData = $(".product-block-wrapper[data-product-type='jacket']").find(".swatch-element[data-option-value='" + colorVal + "']").closest('.swatch-wrap').find('input');
        var variantDataGet = theme_custom.variantDataGet(inputData);
        $(".product-block-wrapper[data-product-type='jacket']").find(".swatch-element").parent(".swatch-wrap").removeClass("unchecked-product");
        $(".product-block-wrapper[data-product-type='jacket']").find(".swatch-element").parent(".swatch-wrap").find("input:radio").prop("checked", false);
        $(".product-block-wrapper[data-product-type='jacket']").find(".swatch-element[data-option-value='" + colorVal + "']").parent(".swatch-wrap").addClass("unchecked-product");
        $(".product-block-wrapper[data-product-type='jacket']").find(".swatch-element[data-option-value='" + colorVal + "']").parent(".swatch-wrap").find("input:radio").prop("checked", true);
        $(".custom-look-image img.jacket-customize-image").attr("src", variantDataGet['variantImage']);
      }
      if ($(".product-block-wrapper[data-product-type='pants']")) {
        var inputData = $(".product-block-wrapper[data-product-type='pants']").find(".swatch-element[data-option-value='" + colorVal + "']").closest('.swatch-wrap').find('input');
        var variantDataGet = theme_custom.variantDataGet(inputData);
        $(".product-block-wrapper[data-product-type='pants']").find(".swatch-element").parent(".swatch-wrap").removeClass("unchecked-product");
        $(".product-block-wrapper[data-product-type='pants']").find(".swatch-element").parent(".swatch-wrap").find("input:radio").prop("checked", false);
        $(".product-block-wrapper[data-product-type='pants']").find(".swatch-element[data-option-value='" + colorVal + "']").parent(".swatch-wrap").addClass("unchecked-product");
        $(".product-block-wrapper[data-product-type='pants']").find(".swatch-element[data-option-value='" + colorVal + "']").parent(".swatch-wrap").find("input:radio").prop("checked", true);
        $(".custom-look-image img.pants-customize-image").removeClass("hide");
        $(".custom-look-image img.pants-customize-image").attr("src", variantDataGet['variantImage']);
      }
      if ($(`.product-block-wrapper[data-product-type="vest"] input:radio:checked`).length > 0) {
        if (localStorage.getItem("customizerlookFrom") == "exiting-looks") {
          var targetVest = $(this).closest(".product-item-wrap").attr("data-vest-handle");
          $(`.product-block-wrapper[data-product-type="vest"]`).find(`.product-item-wrap[data-product-handle="${targetVest}"] .swatch-color input`).click()
        } else {
          var selectedVestVarHandle = $(`.product-block-wrapper[data-product-type="vest"] input:radio:checked`).next(".swatch-element").attr("data-product-handle");
          var selectedVestVarId = $(`.product-block-wrapper[data-product-type="vest"] input:radio:checked`).next(".swatch-element").attr("data-variant-id");
          var productData = selectedVestVarHandle + "=" + selectedVestVarId;
          theme_custom.removeProductOnUncheck(selectedVestVarId, selectedVestVarHandle, productData);
          $(`.product-block-wrapper[data-product-type="vest"]`).find(".swatch-wrap").removeClass("unchecked-product");
          $(".vest-customize-image").addClass("hide");
          $(`.product-block-wrapper[data-product-type="vest"] .price-wrap`).hide();
        }
      }
    }
    if ($(`.product-block-wrapper[data-product-type="belt"] input:radio:checked`).length > 0) {
      var checkTuxedoSelect = $(`.product-block-wrapper[data-product-type="suit"]`).find(`input:radio:checked`).val()
      if (checkTuxedoSelect.includes("Tuxedo")) {
        $(`.product-block-wrapper[data-product-type="belt"]`).closest(`.product-block-outer-wrapper`).find(`.belt-note-message`).addClass("error-show");
      } else {
        $(`.product-block-wrapper[data-product-type="belt"]`).closest(`.product-block-outer-wrapper`).find(`.belt-note-message`).removeClass("error-show");
      }
    }
    if ($(this).closest(".product-block-wrapper[data-product-type='bow-ties']").length > 0) {
      $(".product-block-wrapper[data-product-type='neckties']").find('input[type="radio"]').prop("checked", false);
      $(".product-block-wrapper[data-product-type='neckties']").find('.swatch-wrap.unchecked-product').removeClass("unchecked-product");
      $(".product-block-wrapper[data-product-type='neckties']").closest(".product-block-outer-wrapper").find('.product-title .price-wrap').hide();
      $(".product-block-wrapper[data-product-type='neckties']").closest(".product-block-outer-wrapper").find(".product-title-wrap .color-title").text('');
      $(".neckties-customize-image").addClass("hide");
      theme_custom.removeTieBar();
    } else if ($(this).closest(".product-block-wrapper[data-product-type='neckties']").length > 0) {
      $(".product-block-wrapper[data-product-type='bow-ties']").find('input[type="radio"]').prop("checked", false);
      $(".product-block-wrapper[data-product-type='bow-ties']").find('.swatch-wrap.unchecked-product').removeClass("unchecked-product");
      $(".product-block-wrapper[data-product-type='bow-ties']").closest(".product-block-outer-wrapper").find('.product-title .price-wrap').hide();
      $(".product-block-wrapper[data-product-type='bow-ties']").closest(".product-block-outer-wrapper").find(".product-title-wrap .color-title").text('');
      $(".bow-ties-customize-image").addClass("hide");
      if (parent.find('.not-color input:checked').length == 0) {
        parent.find('.not-color .swatch-wrap:first-child input').prop('checked', true);
      }
      if ($(this).closest('.swatch').hasClass('not-color')) {
        if ($('.product-block-wrapper[data-product-type="neckties"] .swatch-color input:radio:checked').length == 0) {
          parent.find('.swatch-color .swatch-wrap:first-child input').click();
        }
      }
      if ($(".product-block-wrapper[data-product-type='neckties'] .swatch-color input:radio:checked").length > 0) {
        $(`.product-block-wrapper[data-product-type="tie-bar"]`).closest(".product-block-outer-wrapper").show();
        $(`.mobile-tab-content-title[data-target="tie-bar"]`).show();
        $(`.tabbed-content-block-inner-wrapper[data-tab-content="customize"] .continue-button.mobile-next-tab-btn-main`).show();
        $(`.tabbed-content-block-inner-wrapper[data-tab-content="customize"] .continue-button:not(.mobile-next-tab-btn-main)`).hide();
      }
    } else if ($(this).closest(".product-block-wrapper[data-product-type='tie-bar']").length > 0) {
      if (parent.find('.not-color input:checked').length == 0) {
        parent.find('.not-color .swatch-wrap:first-child input').prop('checked', true);
      }
      if ($(this).closest('.swatch').hasClass('not-color')) {
        if ($('.product-block-wrapper[data-product-type="tie-bar"] .swatch-color input:radio:checked').length == 0) {
          parent.find('.swatch-color .swatch-wrap:first-child input').click();
        }
      }
    }
    if ($(this).closest('.product-block-wrapper').attr('data-product-type') == 'hanky' || $(this).closest('.product-block-wrapper').attr('data-product-type') == 'belt') {
      $(".custom-look-image").addClass("image-zoom");
    }
    if ($(this).closest('.product-block-wrapper').attr('data-product-type') == 'shoes') {
      $(".custom-look-image").removeClass("image-zoom");
    }
    if ($(".product-block-wrapper[data-product-type='neckties'] .swatch-color input:radio:checked").length > 0) {
      $(`.product-block-wrapper[data-product-type="tie-bar"]`).closest(".product-block-outer-wrapper").show();
      $(`.mobile-tab-content-title[data-target="tie-bar"]`).show();
      $(`.tabbed-content-block-inner-wrapper[data-tab-content="customize"] .continue-button.mobile-next-tab-btn-main`).show();
      $(`.tabbed-content-block-inner-wrapper[data-tab-content="customize"] .continue-button:not(.mobile-next-tab-btn-main)`).hide();
    }
    if ($('.product-block-wrapper[data-product-type="neckties"] .swatch-color input:radio:checked').length == 0 || $('.product-block-wrapper[data-product-type="neckties"] .not-color input:radio:checked').length == 0) {
      $('.neckties-customize-image').addClass('hide');
    }
    if ($('.product-block-wrapper[data-product-type="bow-ties"] .swatch-color input:radio:checked').length == 0) {
      $('.bow-ties-customize-image').addClass('hide');
    }
    if ($('.product-block-wrapper[data-product-type="belt"] .swatch-color input:radio:checked').length == 0) {
      $('.belt-customize-image').addClass('hide');
    }
    if ($('.product-block-wrapper[data-product-type="hanky"] .swatch-color input:radio:checked').length == 0) {
      $('.hanky-customize-image').addClass('hide');
    }
    if ($('.product-block-wrapper[data-product-type="tie-bar"] .swatch-color input:radio:checked').length == 0 || $('.product-block-wrapper[data-product-type="tie-bar"] .not-color input:radio:checked').length == 0) {
      $('.tie-bar-customize-image').addClass('hide');
    }
    $(this).closest(".swatch-el-outer-wrapper").find("input[type='hidden']").val(colorVal);
    var variantDataGet = theme_custom.variantDataGet($(this));
    parent.attr("data-var-id", variantDataGet['variantId']);
    parent.find(".selected-variant-id").val(variantDataGet['variantId']).attr("data-variant-id", variantDataGet['variantId']);
    if (variantDataGet.variantId != undefined) {
      if ($(this).closest(".product-block-wrapper[data-product-type='suit']").length == 0) {
        if ($(this).closest('.swatch').hasClass('swatch-color')) {
          $(this).closest(".product-block-wrapper").find(".swatch-wrap").removeClass("unchecked-product");
          $(this).parent(".swatch-wrap").addClass("unchecked-product");
        }
        var dataProductType = parent.attr("data-product-type").toLowerCase();
        if (dataProductType == 'shirt') {
          if (($('.product-block-wrapper[data-product-type="neckties"] .swatch-color input:radio:checked').length > 0 && $('.product-block-wrapper[data-product-type="neckties"] .not-color input:radio:checked').length > 0) || $('.product-block-wrapper[data-product-type="bow-ties"] .swatch-color input:radio:checked').length > 0) {
            if (variantDataGet['variantImage'] != undefined) {
              $('.shirt-customize-image').attr('src', variantDataGet['variantImage']);
            }
          } else {
            if (variantDataGet['variantImageOne'] != undefined) {
              $('.shirt-customize-image').attr('src', variantDataGet['variantImageOne']);
            }
          }
        } else {
          if ($(this).closest('.swatch-wrap').hasClass('.swatch-color')) {
            $(".custom-look-image img." + dataProductType + "-customize-image").attr("src", variantDataGet['variantImage']).removeClass("hide");
          } else {
            if ($(this).closest('.swatch-outer-wrapper').find('.swatch-color input:checked').length > 0) {
              $(".custom-look-image img." + dataProductType + "-customize-image").attr("src", variantDataGet['variantImage']).removeClass("hide");
            }
          }
          var shirtVariantDataGet = theme_custom.variantDataGet($('.product-block-wrapper[data-product-type="shirt"] .swatch-color input:radio:checked'));
          if ($('.product-block-wrapper[data-product-type="shirt"] .swatch-color input:radio:checked').length > 0) {
            if (($('.product-block-wrapper[data-product-type="neckties"] .swatch-color input:radio:checked').length > 0 && $('.product-block-wrapper[data-product-type="neckties"] .not-color input:radio:checked').length > 0) || $('.product-block-wrapper[data-product-type="bow-ties"] .swatch-color input:radio:checked').length > 0) {
              if (shirtVariantDataGet['variantImage'] != undefined) {
                $('.shirt-customize-image').attr('src', shirtVariantDataGet['variantImage']);
              }
            } else {
              if (shirtVariantDataGet['variantImageOne'] != undefined) {
                $('.shirt-customize-image').attr('src', shirtVariantDataGet['variantImageOne']);
              }
            }
          } else {
            if (($('.product-block-wrapper[data-product-type="neckties"] .swatch-color input:radio:checked').length > 0 && $('.product-block-wrapper[data-product-type="neckties"] .not-color input:radio:checked').length > 0) || $('.product-block-wrapper[data-product-type="bow-ties"] .swatch-color input:radio:checked').length > 0) {
              $('.shirt-customize-image').attr('src', $('.shirt-customize-image').attr('data-close-collar-image'));
            } else {
              $('.shirt-customize-image').attr('src', $('.shirt-customize-image').attr('data-open-collar-image'));
            }
          }
        }
      } else {
        if ($('.product-block-wrapper[data-product-type="shirt"] .swatch-color input:radio:checked').length == 0) {
          if (($('.product-block-wrapper[data-product-type="neckties"] .swatch-color input:radio:checked').length > 0 && $('.product-block-wrapper[data-product-type="neckties"] .not-color input:radio:checked').length > 0) || $('.product-block-wrapper[data-product-type="bow-ties"] .swatch-color input:radio:checked').length > 0) {
            $('.shirt-customize-image').attr('src', $('.shirt-customize-image').attr('data-close-collar-image'));
          } else {
            $('.shirt-customize-image').attr('src', $('.shirt-customize-image').attr('data-open-collar-image'));
          }
        }
      }
      if (variantDataGet['variantPrice'] != undefined) {
        if ($(this).closest('.swatch-wrap').hasClass('.swatch-color')) {
          $(this).closest(".product-block-outer-wrapper").find(".price-wrap").text('+' + parseInt(variantDataGet['variantPrice']) / 100).show();
        } else {
          if ($(this).closest('.swatch-outer-wrapper').find('.swatch-color input:checked').length > 0) {
            $(this).closest(".product-block-outer-wrapper").find(".price-wrap").text('+' + theme_custom.Shopify.formatMoney(variantDataGet['variantPrice'], theme_custom.money_format)).show();
          }
        }
      }
      theme_custom.setUrlData();
      $(this).closest(".product-block-outer-wrapper").find(".form-error").remove();
      if ($(`.product-block-wrapper[data-product-type="vest"] input:radio:checked`).length > 0) {
        if ($(this).closest(".product-block-wrapper[data-product-type='belt']").length > 0) {
          $(".vest-customize-image").addClass("hide");
        } else {
          $(".vest-customize-image").removeClass("hide");
        }
      }
    } else {
      $(this).closest(".product-block-wrapper").find(`.swatch-color input[type="radio"]`).parent('.swatch-wrap').removeClass("unchecked-product");
      $(this).closest(".product-block-wrapper").find(`.swatch-color input[type="radio"]`).prop('checked', false);
      $(this).closest(".product-block-outer-wrapper").find(".product-title .price-wrap").hide();
      var getCurrentProductType = $(this).closest(".product-item-wrap").attr("data-product-handle");
      var lookProduct = localStorage.getItem("customizerlookUrl").split("&");
      lookProduct.splice(lookProduct.indexOf(getCurrentProductType), 1);
      var newURL = lookProduct.join("&");
      localStorage.setItem("customizerlookUrl", newURL);
      $(`.custom-look-image .${getCurrentProductType}-customize-image`).addClass("hide");
      $(this).parent(".swatch-wrap").removeClass("unchecked-product");
      $(this).closest(".product-block-outer-wrapper").find(".form-error").remove();
      if ($(this).closest(".product-block-wrapper").find(".not-color").length > 0) {
        $(this).closest(".product-block-wrapper").find(`.not-color input[type="radio"]`).prop('checked', false);
      }
      var url_arr = [];
      var productHandleVal = $(this).closest(".product-block.product-item-wrap").attr("data-product-handle"),
        productVarId = $(this).closest(".swatches-wrapper").find(".product-var-dropdown").val();
      var product_data_url = '';
      product_data_url = productHandleVal + '=' + productVarId;
      url_arr.push(product_data_url);
      $(this).closest(".product-block-outer-wrapper").find(".product-title").after(`<p class="form-error" style="display:block;border-bottom: 1px solid #f5f5f5;padding-bottom: 10px;">Sorry, this product combination is not available.</p>`);
      $(this).closest(".product-block-outer-wrapper").find(".form-error").show();
      theme_custom.priceUpdate();
    }
    $(".next-step").removeClass("disabled");
    $(".tabbed-content-title").addClass("tab-header");
    if (getCookie("fit-finder-data") == "") {
      $(".tabbed-content-title[data-target='overview']").removeClass("tab-header");
    }
  });
  $('.product-block-wrapper[data-product-type="suit"] .swatch-wrap input[type=radio]').click(function() {
    var colorVal = $(this).val(),
      parent = $(this).closest(".product-block-wrapper");
    var curTar = $(this).closest(".swatch-wrap").data("value");
    setTimeout(function() {
      $(`.product-block-wrapper[data-product-type="vest"] .swatch-wrap input[value="${curTar}"]`).prop("checked", true);
      $(`.product-block-wrapper[data-product-type="vest"] .swatch-wrap input[value="${curTar}"]`).trigger("change");
    }, 1000)
  });
  var checkSuitDefaultVest = localStorage.getItem("suit_addDefault_vest");
  if (checkSuitDefaultVest) {
    setTimeout(function() {
      $('.product-block-wrapper[data-product-type="suit"] .swatch-wrap input[type=radio]:checked').trigger("click");
      localStorage.removeItem("suit_addDefault_vest");
    }, 500)
  }
  var customizerlookUrl = localStorage.getItem("customizerlookUrl");
  if (customizerlookUrl) {
  } else {
    $("#light-grey-suit-1-color-light-grey").prop("checked", true);
    $("#light-grey-suit-1-color-light-grey").trigger("change");
    $("#light-grey-vest-1-1-color-light-grey").prop("checked", true);
    $("#light-grey-vest-1-1-color-light-grey").trigger("change");
  }
  $(document).on("click", ".fit-finder-button", function() {
    var getLookUrl = localStorage.getItem("customizerlookUrl");
    localStorage.setItem("customizerlookPageFitFinder", "true");
    localStorage.setItem("previous-page-link", "true");
    localStorage.setItem("page-link", '/pages/customize-your-look?' + getLookUrl);
    var getFitFinderPageLink = $(this).attr("data-href");
    if ($(this).hasClass("edit-fit-finder")) {
      localStorage.setItem("edit-fit-finder", "true");
    }
    window.location.href = getFitFinderPageLink;
  });
  $(document).on("click", ".remove-item, .unchecked-product", function() {
    var target = $(this);
    theme_custom.checkParentRemoveProductFlag = 'remove-item';
    if ($(this).closest(`.product-block-wrapper[data-product-type="neckties"]`).length > 0) {
      theme_custom.removeTieBar();
    }
    if ($(this).hasClass('remove-item')) {
      var variantId = $(this).attr('data-variant-id');
    } else {
      var variantDataGet = theme_custom.variantDataGet($(this));
      var variantId = variantDataGet['variantId'];
    }
    var prodHandle = $(this).attr("data-product-handle"),
      productData = prodHandle + "=" + variantId;
    theme_custom.removeProductOnUncheck(variantId, prodHandle, productData, target, theme_custom.checkParentRemoveProductFlag);
  });
}
//  Init Function
theme_custom.customize_product_init = function() {
  theme_custom.customize_product_clickEvent();
  var check_recomm = localStorage.getItem("open_recomm_size");
  if (check_recomm) {
    setTimeout(function() {
      theme_custom.productDataFromURL();
      $(`.tabbed-content-title.tab-header`).removeClass("active");
      $(`.tabbed-content-title.tab-header[data-target="overview"]`).addClass("active");
      $(`.tabbed-content-block-inner-wrapper`).removeClass("active");
      $(`.tabbed-content-block-inner-wrapper[data-tab-content="overview"]`).addClass("active");
      localStorage.removeItem("open_recomm_size");
    }, 1000);
  }
}
// theme_custom.fitFinderData
theme_custom.fitFinderData = function() {
  if (getCookie("fit-finder-data") != "") {
    var getFitFinderData = JSON.parse(getCookie("fit-finder-data"));
    var jacketType = getFitFinderData.jacketSize.split(":");
    var jacketTypeVal = '';
    $(".fit-finder-button").addClass("edit-fit-finder");
    $(".fit-finder-button span").text("Edit Sizes");
    $(".tabbed-content-block-inner-wrapper[data-tab-content='find-your-fit']").find(".section-heading").text("Recommended Sizes");
    if (jacketType[1] == "S") {
      jacketTypeVal = 'Short'
    } else if (jacketType[1] == "R") {
      jacketTypeVal = 'Regular'
    } else if (jacketType[1] == "L") {
      jacketTypeVal = 'Long'
    }
    // Jacket - Size 
    theme_custom.jacketSize = jacketType[0];
    theme_custom.jacketType = jacketTypeVal;
    // Pants Size
    theme_custom.pantsWaist = getFitFinderData.pants_waist;
    theme_custom.pantsLength = getFitFinderData.pants_hight;
    // Shirt size
    theme_custom.shirt_neck = getFitFinderData.shirt_neck;
    theme_custom.shirt_sleeve = getFitFinderData.shirt_sleeve;
    // shirt style
    theme_custom.shirt_sleeve_fit = getFitFinderData.fit;
    // Shoes size
    theme_custom.shoesSize = getFitFinderData.shoe_size;
    var fitFinderDataHtml = `<div class="filed-wrapper">
                              <p class="field__label title">Jacket Size :</p>
                              <p class="value size-result-part">${jacketType[0]} ${jacketTypeVal}</p>
                            </div>
                            <div class="filed-wrapper">
                              <p class="field__label title">Pants Size :</p>
                              <p class="value size-result-part">${getFitFinderData.pants_waist}W, ${getFitFinderData.pants_hight}H</p>
                            </div>
                            <div class="filed-wrapper">
                              <p class="field__label title">Shirt Size :</p>
                              <p class="value size-result-part">Neck ${getFitFinderData.shirt_neck}, Sleeve ${getFitFinderData.shirt_sleeve}</p>
                            </div>
                            <div class="filed-wrapper">
                              <p class="field__label title">Shoe Size :</p>
                              <p class="value size-result-part">${getFitFinderData.shoe_size}</p>
                            </div>`;
    $(".tabbed-content-block-inner-wrapper[data-tab-content='find-your-fit']").find(".fit-finder-data").html(fitFinderDataHtml);
    if (localStorage.getItem("gotoFitFinder")) {
      theme_custom.setUrlData();
      localStorage.removeItem("gotoFitFinder");
    }
  } else {
    $(`[data-product-type="vest"] .variant-title, [data-product-type="shirt"] .variant-title, [data-product-type="shoes"] .variant-title`).addClass('hidden');
    $(`.jacket_option .edit-item, .pants_option .edit-item,[data-product-type="vest"] .edit-item, [data-product-type="shirt"] .edit-item, [data-product-type="shoes"] .edit-item`).attr('data-button-target', 'select-size');
    fitFinderDataHtml = `<div class='my-size-outer-wrapper'>
                          <p>${theme_custom.emptyFitFinderMsg}</p>
                        </div>`
    $(".tabbed-content-block-inner-wrapper[data-tab-content='find-your-fit']").find(".fit-finder-data").html(fitFinderDataHtml);
    $(".tabbed-content-block-inner-wrapper[data-tab-content='find-your-fit']").find(".next-step").addClass("disabled")
  }
}
theme_custom.checkEditLook = function() {
  if (localStorage.getItem("eventLookName") != null && localStorage.getItem("eventLookId") != null && localStorage.getItem("customize-from-event") != null) {
    $(`[data-tab-content='overview']`).find('.add-to-event .add-event-look').addClass("update-look-and-contine").removeClass('add-event-look').find('span').text("Update Look and Continue");
    $(`[data-tab-content='overview']`).find(`.wishlist-add-event-part .wishlist-icon-wrap, .product-share-button, .product-info-footer .button-wrapper`).hide();
  }
  if (localStorage.getItem("editLookName") != null && localStorage.getItem("editLookId") != null && localStorage.getItem("look-for-favourite") != null) {
    $(`[data-tab-content='overview']`).find('.wishlist-icon-wrap').addClass("update-look-and-countinue");
    $(`[data-tab-content='overview']`).find('.wishlist-icon-wrap .favorite-event-button').addClass("update-look");
    $(`[data-tab-content='overview']`).find('.wishlist-icon-wrap .favorite-event-button span').text("Update Look and Continue");
    $(`.favourite-look-wrapper`).find('.favorite-event-api-button').attr('data-text', 'Updating Look');
    $(`.favourite-look-wrapper`).find('.favorite-event-api-button .button-title').text('Update Look');
    $(`[data-tab-content='overview']`).find(`.wishlist-add-event-part .add-to-event, .product-share-button, .product-info-footer .button-wrapper`).hide();
  }
  if (localStorage.getItem("set-event-id") != null && localStorage.getItem("customise-look-button-for-add-look-into-event") != null) {    
    $(`[data-tab-content='overview']`).find('.wishlist-add-event-part .add-to-event').addClass("add-look-and-countinue");
    $(`[data-tab-content='overview']`).find('.wishlist-add-event-part .add-to-event span').text("Add Look and Continue");
    $(`[data-tab-content='overview']`).find(`.wishlist-add-event-part .wishlist-icon-wrap, .product-share-button, .product-info-footer .button-wrapper`).hide();
  }
}
//  DOM Ready function
$(document).ready(function() {
  theme_custom.checkEditLook();
  theme_custom.customize_product_init();
  $(".product-block.product-item-wrap").each(function() {
    var parentBlock = $(this).closest(".product-block.product-item-wrap"),
      variantTitle = '';
    if (parentBlock.find('[data-option-index="0"]').length > 0) {
      variantTitle = parentBlock.find('[data-option-index="0"]').val();
    }
    if (parentBlock.find('[data-option-index="1"]').length > 0) {
      variantTitle = variantTitle + ' / ' + parentBlock.find('[data-option-index="1"]').val();
    }
    if (parentBlock.find('[data-option-index="2"]').length > 0) {
      variantTitle = variantTitle + ' / ' + parentBlock.find('[data-option-index="2"]').val();
    }
    parentBlock.find('.product-var-dropdown option').removeAttr('selected').filter('[data-variant-title="' + variantTitle + '"]').prop('selected', true);
    parentBlock.find(`.product-var-dropdown option[data-variant-title="${variantTitle}"]`).prop('selected', true);
    parentBlock.attr("data-var-id", parentBlock.find('.product-var-dropdown').val());
    parentBlock.find(".selected-variant-id").val(parentBlock.find('.product-var-dropdown').val()).attr("data-variant-id", parentBlock.find('.product-var-dropdown').val());
  });
  theme_custom.mobile_accordion();
  var radioHasChecked = $(".product-item-wrap [type='radio']:checked").length;
  if (radioHasChecked == 0) {
    $(".tabbed-content-block-outer-wrapper:first").find(".next-step").addClass("disabled");
  }
  if (localStorage.getItem("customizerlookUrl")) {
    var customizer_look_url = localStorage.getItem("customizerlookUrl");
    history.pushState(null, '', '');
    history.pushState(null, '', '?' + customizer_look_url);
  }
  theme_custom.productDataFromURL();
  setTimeout(function() {
    theme_custom.fitFinderData();
  }, 500);
  if (localStorage.getItem("gotoFitFinder")) {
    $(".tabbed-content-title").removeClass("active");
    $(".tabbed-content-title[data-target='overview']").addClass("active");
    $(".tabbed-content-block-inner-wrapper").removeClass("active");
    $(".tabbed-content-block-inner-wrapper[data-tab-content='overview']").addClass("active");
  }
  var exitingLookUrl = window.location.href;
  if (exitingLookUrl.includes('?')) {
    var exitingLookUrlUrlArr = exitingLookUrl.split('?');
    var ExitingLookURL = exitingLookUrlUrlArr[1];
    localStorage.setItem("customizerlookUrl", ExitingLookURL);
  }
  // Click function
  $('.customize_product_title').click(function() {
    $('.customize_product_title').removeClass('active');
    $(this).addClass('active');
    $(this).closest(`.product-block-outer-wrapper`).find(`.product-item-wrap`).hide();
    var selectedProduct = $(this).attr("data-product-type-handle");
    $(this).closest(`.product-block-outer-wrapper`).find(".swatch-color .swatch-wrap input").prop("checked", false);
    $(this).closest(`.product-block-outer-wrapper`).find(".swatch-color .swatch-wrap").removeClass("unchecked-product");
    $(this).closest(`.product-block-outer-wrapper`).find(`.product-item-wrap[data-product-handle='${selectedProduct}']`).show();
    $(this).closest(`.product-block-outer-wrapper`).find(`.product-item-wrap[data-product-handle='${selectedProduct}']`).find(".swatch-color .swatch-wrap:first-child input").click();
    return false;
  });
  $(document).on('change', '.product-variant-option', function() {
    var targetVal = $(this).val(),
      targetQty = $(this).closest(".product-swatch-option").find(`.product-variant-option option[value='${targetVal}']`).attr("data-variant-inventory-quantity"),
      productHandle = $(this).closest(".product-swatch-option").attr("data-product-handle");
    if (targetQty == 0) {
      $(this).closest(".product-swatch-option").append(`<p clas="error-message error-show" style='text-align:center'>${theme_custom.product_unavailable}</p>`);
      $(this).closest(".product-swatch-option").find(".exchange-look-item").addClass("disabled");
    } else {
      $(`.customize-look-overview-product[data-product-handle='${productHandle}']`).find(".error-message").addClass("hidden");
      $(`.customize-look-overview-product[data-product-handle='${productHandle}']`).addClass("product-block-var-data");
      $(`.customize-look-overview-product[data-product-handle='${productHandle}']`).find(".overview-variant-id").val(targetVal);
      $(this).closest(".product-swatch-option .error-message").remove();
      $(this).closest(".product-swatch-option").find(".exchange-look-item").removeClass("disabled");
    }
  });
  $(".custom-tabs-scroll").each(function(index, item) {
    theme_custom.customTabsScroll($(item).find(".swatch-wrap"));
  });
  if (localStorage.getItem("page-refresh") == 'true') {
    setTimeout(() => {
      $(`.tabbed-content-title`).removeClass(`active`);
      $(`.tabbed-content-title[data-target="overview"]`).addClass(`active`)
      $(`.tabbed-content-block-inner-wrapper`).removeClass(`active`);
      $(`.tabbed-content-block-inner-wrapper[data-tab-content="overview"]`).addClass(`active`)
      localStorage.removeItem("page-refresh")
    }, 1500);
  }
})
// custom-tabs-scroll start
var filterWrapWidth,
  swatchFilterWrapWidth,
  scrollSize = 350,
  totalScrollSize,
  swatchTotalScrollSize,
  blankSpace;
if (window.matchMedia("(max-width: 749px)").matches) {
  blankSpace = 19.5;
} else {
  blankSpace = 19.5;
}
$(document).on("click", ".custom-tabs-scroll .left-paddle", function(e) {
  e.preventDefault();
  var parent = $(this).closest(".custom-tabs-scroll");
  var filterWrap = parent.find(".product-block-wrapper");
  var swatchFilterWrap = parent.find(".custom-tabs-scroll-swatch");
  var filterWrapLeftArrow = parent.find(".left-paddle");
  var filterWrapRightArrow = parent.find(".right-paddle");
  totalScrollSize = filterWrap.scrollLeft() - scrollSize;
  filterWrap.animate({
    scrollLeft: totalScrollSize
  }, 300);
  swatchTotalScrollSize = swatchFilterWrap.scrollLeft() - scrollSize;
  swatchFilterWrap.animate({
    scrollLeft: swatchTotalScrollSize
  }, 300);
  filterWrapRightArrow.removeClass("hidden");
  if (totalScrollSize <= 0) {
    filterWrapLeftArrow.addClass("hidden");
  }
  if (swatchTotalScrollSize <= 0) {
    filterWrapLeftArrow.addClass("hidden");
  }
});
$(document).on("click", ".custom-tabs-scroll .right-paddle", function(e) {
  e.preventDefault();
  var parent = $(this).closest(".custom-tabs-scroll");
  var filterWrap = parent.find(".product-block-wrapper");
  var swatchFilterWrap = parent.find(".custom-tabs-scroll-swatch");
  var filterWrapLeftArrow = parent.find(".left-paddle");
  var filterWrapRightArrow = parent.find(".right-paddle");
  totalScrollSize = filterWrap.scrollLeft() + scrollSize;
  filterWrap.animate({
    scrollLeft: totalScrollSize
  }, 300);
  swatchTotalScrollSize = swatchFilterWrap.scrollLeft() + scrollSize;
  swatchFilterWrap.animate({
    scrollLeft: swatchTotalScrollSize
  }, 300);
  filterWrapLeftArrow.removeClass("hidden");
  var filterWrapWidth = 0;
  var swatchFilterWrapWidth = 0;
  parent.find(".product-block-wrapper .product-item-wrap").each(function(index, value) {
    filterWrapWidth += $(value).width() + blankSpace;
  });
  parent.find(".custom-tabs-scroll-swatch .swatch-wrap").each(function(index, value) {
    swatchFilterWrapWidth += $(value).width() + blankSpace;
  });
  if (totalScrollSize >= filterWrapWidth) {
    filterWrapRightArrow.addClass("hidden");
  }
  if (swatchTotalScrollSize >= swatchFilterWrapWidth) {
    filterWrapRightArrow.addClass("hidden");
  }
});
theme_custom.customTabsScroll = function($this) {
  filterWrapWidth = 0;
  var parent = $this.closest(".custom-tabs-scroll");
  var filterWrap = parent.find(".product-block-wrapper");
  var swatchFilterWrap = parent.find(".custom-tabs-scroll-swatch");
  var filterWrapLeftArrow = parent.find(".left-paddle");
  var filterWrapRightArrow = parent.find(".right-paddle");
  parent.closest('.tabbed-content-block-inner-wrapper:not(.active)').css({
    position: "absolute",
    left: 0,
    right: 0,
    visibility: "hidden",
    display: "block"
  });
  parent.closest('.product-block-outer-wrapper:not(.active)').addClass('customize_visible').css({
    position: "absolute",
    visibility: "hidden",
    display: "block"
  });
  var parentWidth = parent.width();
  if (parent.find(".product-block-wrapper").length > 0) {
    parent.closest('.tabbed-content-block-inner-wrapper:not(.active)').css({
      position: "",
      left: '',
      right: '',
      visibility: "",
      display: ""
    });
    parent.closest('.product-block-outer-wrapper:not(.active)').removeClass('customize_visible').css({
      position: "",
      visibility: "",
      display: ""
    });
  }
  var filterWrapWidth = 0;
  var swatchFilterWrapWidth = 0;
  parent.find(".product-block-wrapper .product-item-wrap:visible").each(function(index, value) {
    filterWrapWidth += $(value).width() + blankSpace;
  });
  parent.find(".custom-tabs-scroll-swatch .swatch-wrap").each(function(index, value) {
    swatchFilterWrapWidth += $(value).width() + blankSpace;
  });
  if (parent.find(".custom-tabs-scroll-swatch").length > 0) {
    parent.closest('.tabbed-content-block-inner-wrapper:not(.active)').css({
      position: "",
      left: '',
      right: '',
      visibility: "",
      display: ""
    });
    parent.closest('.product-block-outer-wrapper:not(.active)').removeClass('customize_visible').css({
      position: "",
      visibility: "",
      display: ""
    });
  }
  totalScrollSize = filterWrap.scrollLeft() + parentWidth;
  swatchTotalScrollSize = swatchFilterWrap.scrollLeft() + parentWidth;
  if ((totalScrollSize >= filterWrapWidth - 5 || filterWrapWidth < parentWidth) && parent.find(".product-block-wrapper").length > 0) {
    filterWrapRightArrow.addClass("hidden");
  } else if ((swatchTotalScrollSize >= swatchFilterWrapWidth - 5 || swatchFilterWrapWidth < parentWidth) && parent.find(".custom-tabs-scroll-swatch").length > 0) {
    filterWrapRightArrow.addClass("hidden");
  } else {
    filterWrapRightArrow.removeClass("hidden");
  }
  if (filterWrap.scrollLeft() <= 0 && parent.find(".product-block-wrapper").length > 0) {
    filterWrapLeftArrow.addClass("hidden");
  } else if (swatchFilterWrap.scrollLeft() <= 0 && parent.find(".custom-tabs-scroll-swatch").length > 0) {
    filterWrapLeftArrow.addClass("hidden");
  } else {
    filterWrapLeftArrow.removeClass("hidden");
  }
};
$(".custom-tabs-scroll .product-block-wrapper, .custom-tabs-scroll .custom-tabs-scroll-swatch").on("load resize scroll", function() {
  theme_custom.customTabsScroll($(this));
});
$(window).resize(function() {
  $(".custom-tabs-scroll").each(function(index, item) {
    theme_custom.customTabsScroll($(item).find(".product-block-wrapper"));
    theme_custom.customTabsScroll($(item).find(".custom-tabs-scroll-swatch"));
  });
  if (window.matchMedia("(max-width: 749px)").matches) {
    blankSpace = 19.5;
  } else {
    blankSpace = 19.5;
  }
});
theme_custom.setNoramlProductVariants = function() {
  const tiesDiv = $('.product-block-wrapper[data-product-type="neckties"]');
  const ties = $('.product-var-dropdown.select__select option:selected', tiesDiv);
  if (ties) {
    let values = ties.attr('data-variant-title').split(' / ');
    let tiesReview = $('.customize-look-overview-product[data-product-handle="neckties-1"] .product-swatches-main');
    $('.swatches', tiesReview).each((i, item) => {
      $(`.swatch-element-item[data-value="${theme_custom.handleize(values[i])}"]`, item).click();
    })
  }
  const pocketSquareDiv = $('.product-block-wrapper[data-product-type="hanky"]');
  const pocketSquare = $('.product-var-dropdown.select__select option:selected', pocketSquareDiv);
  if (pocketSquare) {
    let values = pocketSquare.attr('data-variant-title').split(' / ');
    let pocketSquareReview = $('.customize-look-overview-product[data-product-handle="pocket-square-2"] .product-swatches-main');
    $('.swatches', pocketSquareReview).each((i, item) => {
      $(`.swatch-element-item[data-value="${theme_custom.handleize(values[i])}"]`, item).click();
    })
  }
  const bowTiesDiv = $('.product-block-wrapper[data-product-type="bow-ties"]');
  const bowTies = $('.product-var-dropdown.select__select option:selected', bowTiesDiv);
  if (bowTies) {
    let values = bowTies.attr('data-variant-title').split(' / ');
    let bowTiesReview = $('.customize-look-overview-product[data-product-type="bow-ties"] .product-swatches-main');
    $('.swatches', bowTiesReview).each((i, item) => {
      $(`.swatch-element-item[data-value="${theme_custom.handleize(values[i])}"]`, item).click();
    })
  }
  const tieBarDiv = $('.product-block-wrapper[data-product-type="tie-bar"]');
  const tieBar = $('.product-var-dropdown.select__select option:selected', tieBarDiv);
  if (tieBar) {
    let values = tieBar.attr('data-variant-title').split(' / ');
    let tieBarReview = $('.customize-look-overview-product[data-product-handle="tie-bar"] .product-swatches-main');
    $('.swatches', tieBarReview).each((i, item) => {
      $(`.swatch-element-item[data-value="${theme_custom.handleize(values[i])}"]`, item).click();
    })
  }
  const beltDiv = $('.product-block-wrapper[data-product-type="belt"]');
  const belt = $('.product-var-dropdown.select__select option:selected', beltDiv);
  if (belt) {
    let values = belt.attr('data-variant-title').split(' / ');
    let beltReview = $('.customize-look-overview-product[data-product-type="belt"] .product-swatches-main');
    $('.swatches', beltReview).each((i, item) => {
      $(`.swatch-element-item[data-value="${theme_custom.handleize(values[i])}"]`, item).click();
    })
  }
  const shoes = $('.product-block-wrapper[data-product-type="shoes"] .swatch-outer-wrapper .swatch-wrap.unchecked-product .product-var-dropdown.select__select');
}
theme_custom.updatePreviousSwatch = function(productType) {
  let tiesReview = $(`.customize-look-overview-product[data-product-type="${productType}"]`);
  const ties = $('.product-variant-option option:selected', tiesReview);
  if (ties) {
    let values = ties.attr('data-variant-title').split(' / ');
    const tiesDiv = $(`.product-block-wrapper[data-product-type="${productType}"]`);
    const option0 = $('.swatch[data-option-index="0"]', tiesDiv)
    const option1 = $('.swatch[data-option-index="1"]', tiesDiv)
    const option2 = $('.swatch[data-option-index="2"]', tiesDiv)
    if (option0.length > 0) {
      $(`.swatch-wrap[data-value="${values[0]}"] label`, option0).click();
    }
    if (option1.length > 0) {
      $(`.swatch-wrap[data-value="${values[1]}"] label`, option1).click();
    }
    if (option2.length > 0) {
      $(`.swatch-wrap[data-value="${values[2]}"] label`, option2).click();
    }
  }
}
$(document).on('click', ".product-image-wrap .download-img-btn", function() {
  theme_custom.saveImage();
});
theme_custom.saveImage = function() {
  let b64data = '';
  let finalCoverImage = document.querySelector(".custom-look-image");
  html2canvas(finalCoverImage, {
    useCORS: true,
    allowTaint: true,
    backgroundColor: "#f5f5f5"
  }).then(canvas => {
    b64data = canvas.toDataURL();
    theme_custom.downloadBase64File(b64data, 'image/png', 'test.png');
  });
}
theme_custom.downloadBase64File = function(base64Data, contentType, fileName) {
  const linkSource = base64Data;
  const downloadLink = document.createElement("a");
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
}
theme_custom.removeLookFromEvent = function(button) {
  var eventLookId = localStorage.getItem("eventLookId");
  theme_custom.button = button;
  $.ajax({
    url: `${theme_custom.base_url}/api/look/removeFromEvent/${eventLookId}`,
    method: "DELETE",
    data: '',
    dataType: "json",
    headers: {
      "Authorization": 'Bearer ' + localStorage.getItem("customerToken")
    },
    beforeSend: function() {
      // $('.favorite-looks-wrapper').css('cursor','not-allowed');
    },
    success: function() {
      theme_custom.addLookToEvent(theme_custom.button);
    },
    error: function(xhr, status, error) {
      if (xhr.responseJSON.message == 'Token is invalid or expired.') {
        alert('Something went wrong <a class="try-again-link" href="/account/login">Please try again</a>');
        setTimeout(() => {
          theme_custom.removeLocalStorage();
          window.location.href = '/account/logout';
        }, 5000);
      } else {
        alert(xhr.responseJSON.message);
      }
    }
  });
}